import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSlice } from "@reduxjs/toolkit";
import { io } from "socket.io-client";

const initialState = {
  isOpen: false,
  selectedCategory: "jeton",
  unreadCount: 0,
  isAdminOnline: false,
  isShowingFavorites: false,
  callState: "idle",
  isMuted: false,
  isVideoOn: false,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatOpen: (state, action) => { state.isOpen = action.payload; },
    setSelectedCategory: (state, action) => { state.selectedCategory = action.payload; },
    resetSelectedCategory: (state) => { state.selectedCategory = null; },
    setUnreadCount: (state, action) => { state.unreadCount = action.payload; },
    setAdminOnline: (state, action) => { state.isAdminOnline = action.payload; },
    setShowingFavorites: (state, action) => { state.isShowingFavorites = action.payload; },
    setCallState: (state, action) => { state.callState = action.payload; },
    setMuted: (state, action) => { state.isMuted = action.payload; },
    setVideoOn: (state, action) => { state.isVideoOn = action.payload; },
  },
});

export const { setChatOpen, setSelectedCategory, resetSelectedCategory, setUnreadCount, setAdminOnline, setShowingFavorites, setCallState, setMuted, setVideoOn } = chatSlice.actions;
export const chatReducer = chatSlice.reducer;


const CHAT_LEGACY_SCRIPT = String.raw`

    (function () {

      "use strict";

      if (typeof io === "undefined") {
        console.error("Socket.io yüklənmədi!");
        return;
      }


      /* ===================================================
         SERVER
      =================================================== */

      const SERVER_URL = "https://artim.shop";
      const SOCKET_PATH = "/chatBotApi/socket.io";


      /* ===================================================
         SOCKET
      =================================================== */

      const socket = io(SERVER_URL, {
        path: SOCKET_PATH,
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000
      });


      /* ===================================================
         ICE
      =================================================== */

      const ICE_SERVERS = {
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          { urls: "stun:stun1.l.google.com:19302" },
          { urls: "stun:stun.relay.metered.ca:80" },
          {
            urls: "turn:global.relay.metered.ca:80",
            username: "042b5b227413dd3f6512c03e",
            credential: "8rNPtPUrwsirwPKy",
          },
          {
            urls: "turn:global.relay.metered.ca:80?transport=tcp",
            username: "042b5b227413dd3f6512c03e",
            credential: "8rNPtPUrwsirwPKy",
          },
          {
            urls: "turn:global.relay.metered.ca:443",
            username: "042b5b227413dd3f6512c03e",
            credential: "8rNPtPUrwsirwPKy",
          },
          {
            urls: "turns:global.relay.metered.ca:443?transport=tcp",
            username: "042b5b227413dd3f6512c03e",
            credential: "8rNPtPUrwsirwPKy",
          },
        ],
      };


      /* ===================================================
         ROOM & USER
      =================================================== */

      let roomId = localStorage.getItem("chat_room_id");
      if (!roomId) {
        roomId = "room_" + Math.random().toString(36).substring(2, 9);
        localStorage.setItem("chat_room_id", roomId);
      }

      let userCallId = localStorage.getItem("chat_user_call_id");
      if (!userCallId) {
        userCallId = "user_" + Math.random().toString(36).substring(2, 11);
        localStorage.setItem("chat_user_call_id", userCallId);
      }

      const userCallName = localStorage.getItem("userName") || localStorage.getItem("name") || "İstifadəçi";
      const userCallPhoto = localStorage.getItem("userPhoto") || localStorage.getItem("photo") || "";


      /* ===================================================
         LOCAL WELCOME MESSAGE
         Backend/socket-a göndərilmir.
      =================================================== */

      function getWelcomeUserInfo() {
        const info = (typeof store !== "undefined" && store && store.userInfo)
          ? store.userInfo
          : {};

        return {
          name: info.name || info.username || info.firstName || "Hörmətli istifadəçi"
        };
      }

      function getCurrentUserPhoto() {
        const info = (typeof store !== "undefined" && store && store.userInfo) ? store.userInfo : {};
        return info.photo || info.profilePhoto || "";
      }

      function getWelcomeText() {
        const { name } = getWelcomeUserInfo();
        return [
          "Salam 👋",
          "Xoş gəlmisiniz, hörmətli " + name + "!",
          "Sizə necə kömək edə bilərik?"
        ];
      }

      function ensureInChatWelcome(options) {
        if (!messagesEl) return;

        options = options || {};
        const animate = options.animate === true;
        const existing = document.getElementById("local-chat-welcome-message");

        if (existing) {
          if (animate) {
            startWelcomeAnimation(existing);
          } else if (options.static === true) {
            showWelcomeStatic(existing);
          }
          return existing;
        }

        const welcomeMessages = getWelcomeText();
        const div = document.createElement("div");
        div.id = "local-chat-welcome-message";
        div.className = "w-full flex flex-col items-start gap-2.5 py-2 px-1";

        if (!document.getElementById("chat-welcome-animation-style")) {
          const style = document.createElement("style");
          style.id = "chat-welcome-animation-style";
          style.textContent =
            "@keyframes chatWelcomeIn{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}" +
            "@keyframes chatTypingDot{0%,60%,100%{opacity:.25;transform:translateY(0)}30%{opacity:1;transform:translateY(-2px)}}" +
            ".welcome-typing-dot{animation:chatTypingDot 1.1s ease-in-out infinite}" +
            ".welcome-typing-dot:nth-child(2){animation-delay:.15s}" +
            ".welcome-typing-dot:nth-child(3){animation-delay:.3s}";
          document.head.appendChild(style);
        }

        const avatar = function (icon) {
          return '<div class="w-7 h-7 rounded-full shrink-0 overflow-hidden bg-gradient-to-br from-indigo-500 to-violet-600 text-white flex items-center justify-center shadow-sm border border-white/80 dark:border-slate-700 transition-transform duration-200 group-hover:scale-105"><span class="text-xs">' + icon + '</span></div>';
        };

        const bubble = function (text, extra) {
          return '<div class="relative bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 rounded-2xl rounded-bl-md border border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 px-3.5 py-2.5 ' + (extra || '') + '">' + text + '</div>';
        };

        const typing = function () {
          return '<div class="welcome-typing flex items-center gap-1.5 px-3.5 py-2.5 bg-white dark:bg-slate-800 rounded-2xl rounded-bl-md border border-slate-200 dark:border-slate-700 shadow-sm">' +
            '<span class="welcome-typing-dot w-1.5 h-1.5 rounded-full bg-slate-400"></span>' +
            '<span class="welcome-typing-dot w-1.5 h-1.5 rounded-full bg-slate-400"></span>' +
            '<span class="welcome-typing-dot w-1.5 h-1.5 rounded-full bg-slate-400"></span>' +
          '</div>';
        };

        div.innerHTML =
          '<div class="flex items-end gap-2 max-w-[88%] group welcome-line welcome-line-1">' +
            avatar('👋') +
            bubble('<div class="text-[13px] leading-relaxed font-medium">' + escapeHtml(welcomeMessages[0]) + '</div>') +
          '</div>' +
          '<div class="welcome-typing-row items-end gap-2 max-w-[88%] hidden">' +
            avatar('👨‍💼') +
            typing() +
          '</div>' +
          '<div class="items-end gap-2 max-w-[88%] group welcome-line welcome-line-2 hidden">' +
            avatar('👨‍💼') +
            bubble('<div class="text-[10px] font-bold text-indigo-600 dark:text-indigo-400 mb-0.5">Artım.shop</div><div class="text-[13px] leading-relaxed font-medium">' + escapeHtml(welcomeMessages[1]) + '</div>') +
          '</div>' +
          '<div class="welcome-typing-row-2 items-end gap-2 max-w-[88%] hidden">' +
            avatar('💬') +
            typing() +
          '</div>' +
          '<div class="items-end gap-2 max-w-[88%] group welcome-line welcome-line-3 hidden">' +
            avatar('💬') +
            bubble('<div class="text-[13px] leading-relaxed font-medium">' + escapeHtml(welcomeMessages[2]) + '</div>') +
          '</div>';

        messagesEl.insertBefore(div, messagesEl.firstChild);

     if (animate) {
  startWelcomeAnimation(div);
} else if (options.static === true) {
  showWelcomeStatic(div);
}

        return div;
      }

      function showWelcomeStatic(container) {
        if (!container) return;

        if (container._welcomeTimers) {
          container._welcomeTimers.forEach(clearTimeout);
          container._welcomeTimers = [];
        }

        const lines = container.querySelectorAll(".welcome-line");
        lines.forEach(function (line) {
          line.classList.remove("hidden");
          line.classList.add("flex");
          line.style.opacity = "1";
          line.style.transform = "none";
          line.style.animation = "none";
        });

        container.querySelectorAll(".welcome-typing-row, .welcome-typing-row-2").forEach(function (row) {
          row.classList.add("hidden");
        });
      }

      function startWelcomeAnimation(container) {
        if (!container) return;
        if (container._welcomeAnimated) return;
        container._welcomeAnimated = true;

        if (container._welcomeTimers) {
          container._welcomeTimers.forEach(clearTimeout);
        }
        container._welcomeTimers = [];

        const first = container.querySelector(".welcome-line-1");
        const typing1 = container.querySelector(".welcome-typing-row");
        const second = container.querySelector(".welcome-line-2");
        const typing2 = container.querySelector(".welcome-typing-row-2");
        const third = container.querySelector(".welcome-line-3");

        if (first) {
          first.classList.remove("hidden");
          first.style.animation = "none";
          first.style.opacity = "1";
        }

        if (typing1) {
          typing1.classList.remove("hidden");
          typing1.classList.add("flex");
        }

        container._welcomeTimers.push(setTimeout(function () {
          if (typing1) typing1.classList.add("hidden");
          if (second) {
            second.classList.remove("hidden");
            second.classList.add("flex");
            second.style.animation = "chatWelcomeIn .38s ease-out both";
          }
          if (typing2) {
            typing2.classList.remove("hidden");
            typing2.classList.add("flex");
          }
        }, 1000));

        container._welcomeTimers.push(setTimeout(function () {
          if (typing2) typing2.classList.add("hidden");
          if (third) {
            third.classList.remove("hidden");
            third.classList.add("flex");
            third.style.animation = "chatWelcomeIn .38s ease-out both";
          }
        }, 2000));
      }

      function markUserHasSentMessage() {
        // Welcome mesajları real mesajdan sonra da chatda qalır.
        ensureInChatWelcome();
      }

      window.refreshChatWelcome = function () {
        const callout = document.getElementById("chat-widget-callout");
        const isChatOpen = windowEl && !windowEl.classList.contains("hidden");

        if (callout) {
          if (isChatOpen) {
            callout.classList.add("hidden");
            callout.classList.remove("flex");
          } else {
            callout.classList.remove("hidden");
            callout.classList.add("flex");
          }
        }

        // Chat hər açıldıqda 3 welcome mesajını göstər.
        // Heç bir localStorage istifadə olunmur.
        if (isChatOpen && selectedCategory && messagesEl) {
          ensureInChatWelcome();
        }
      };


      /* ===================================================
         AUDIO & SOUNDS
      =================================================== */

      let audioCtx = null;

      function initAudioCtx() {
        try {
          if (!audioCtx) {
            audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          }
          if (audioCtx.state === "suspended") {
            audioCtx.resume();
          }
        } catch (error) {
          console.warn("AudioContext xətası:", error);
        }
      }

      function playNotificationSound(type) {
        try {
          initAudioCtx();
          if (!audioCtx) return;

          const osc = audioCtx.createOscillator();
          const gain = audioCtx.createGain();
          osc.connect(gain);
          gain.connect(audioCtx.destination);

          if (type === "incoming") {
            osc.type = "sine";
            osc.frequency.setValueAtTime(750, audioCtx.currentTime);
            osc.frequency.setValueAtTime(1000, audioCtx.currentTime + 0.05);
            gain.gain.setValueAtTime(0, audioCtx.currentTime);
            gain.gain.linearRampToValueAtTime(0.1, audioCtx.currentTime + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.25);
            osc.start();
            osc.stop(audioCtx.currentTime + 0.25);
          } else if (type === "read") {
            osc.type = "sine";
            osc.frequency.setValueAtTime(1200, audioCtx.currentTime);
            osc.frequency.setValueAtTime(1600, audioCtx.currentTime + 0.04);
            gain.gain.setValueAtTime(0, audioCtx.currentTime);
            gain.gain.linearRampToValueAtTime(0.04, audioCtx.currentTime + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.15);
            osc.start();
            osc.stop(audioCtx.currentTime + 0.15);
          } else if (type === "played") {
            osc.type = "triangle";
            osc.frequency.setValueAtTime(880, audioCtx.currentTime);
            gain.gain.setValueAtTime(0.04, audioCtx.currentTime);
            osc.start();
            gain.gain.exponentialRampToValueAtTime(0.00001, audioCtx.currentTime + 0.1);
            osc.stop(audioCtx.currentTime + 0.1);
          } else if (type === "outgoing") {
            osc.type = "sine";
            osc.frequency.setValueAtTime(600, audioCtx.currentTime);
            osc.frequency.setValueAtTime(800, audioCtx.currentTime + 0.08);
            gain.gain.setValueAtTime(0, audioCtx.currentTime);
            gain.gain.linearRampToValueAtTime(0.05, audioCtx.currentTime + 0.01);
            gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.3);
            osc.start();
            osc.stop(audioCtx.currentTime + 0.3);
          }
        } catch (error) {
          console.warn("Notification sound xətası:", error);
        }
      }


      /* ===================================================
         DOM ELEMENTS
      =================================================== */

      const toggleBtn = document.getElementById("chat-widget-toggle");
      const closeMobileBtn = document.getElementById("chat-widget-close-mobile");
      const badgeEl = document.getElementById("chat-widget-badge");
      const userUnreadBadge = document.getElementById("userUnreadBadge");
      const userUnreadBadgeText = document.getElementById("userUnreadBadgeText");
      const windowEl = document.getElementById("chat-widget-window");
      const messagesEl = document.getElementById("chat-widget-messages");
      const formEl = document.getElementById("chat-widget-form");
      const inputEl = document.getElementById("chat-widget-input");
      const fileInputEl = document.getElementById("chat-widget-file");
      const fileBtnEl = document.getElementById("chat-widget-file-btn");
      const submitBtnEl = document.getElementById("chat-widget-submit-btn");
      const previewContainer = document.getElementById("chat-widget-preview-container");
      const previewImg = document.getElementById("chat-widget-preview-img");
      const previewName = document.getElementById("chat-widget-preview-name");
      const cancelBtn = document.getElementById("chat-widget-cancel-btn");
      const voiceBtnEl = document.getElementById("chat-widget-voice-btn");
      const voiceBtnIcon = document.getElementById("voice-btn-icon");
      const voiceContainer = document.getElementById("chat-widget-voice-container");
      const voiceTimerEl = document.getElementById("chat-widget-voice-timer");
      const voiceCancelBtn = document.getElementById("chat-widget-voice-cancel-btn");
      const voicePing = document.getElementById("chat-widget-voice-ping");
      const voiceWaves = document.getElementById("chat-widget-voice-waves");
      const typingIndicatorEl = document.getElementById("chat-widget-typing-indicator");
      const adminDotEl = document.getElementById("chat-widget-admin-dot");
      const adminTextEl = document.getElementById("chat-widget-admin-text");
      const adminActivityEl = document.getElementById("chat-widget-admin-activity");
      let adminActivityTimeout = null;

      const replyContainer = document.getElementById("chat-widget-reply-container");
      const replyTitle = document.getElementById("chat-widget-reply-title");
      const replyTextEl = document.getElementById("chat-widget-reply-text");
      const replyCancelBtn = document.getElementById("chat-widget-reply-cancel-btn");


      /* ===================================================
         CATEGORY LOGIC
      =================================================== */

      let selectedCategory = "jeton";
      localStorage.setItem("chat_category", "jeton");

    


      /* ===================================================
         CALL STATE & WEBRTC
      =================================================== */

      let callState = "idle";
      let incomingCallData = null;
      let isMuted = false;
      let isVideoOn = false;
      let pc = null;
      let localStream = null;
      let pendingIceCandidates = [];
      let remoteDescriptionSet = false;

      const callOverlay = document.getElementById("call-overlay");
      const remoteVideo = document.getElementById("remoteVideo");
      const localVideo = document.getElementById("localVideo");
      const callAudioPlaceholder = document.getElementById("call-audio-placeholder");
      const callNameEl = document.getElementById("call-name");
      const callStatusEl = document.getElementById("call-status");
      const callingCallButtons = document.getElementById("calling-call-buttons");
      const cancelCallBtn = document.getElementById("cancel-call-btn");
      const incomingCallButtons = document.getElementById("incoming-call-buttons");
      const connectedCallButtons = document.getElementById("connected-call-buttons");
      const acceptCallBtn = document.getElementById("accept-call-btn");
      const rejectCallBtn = document.getElementById("reject-call-btn");
      const muteCallBtn = document.getElementById("mute-call-btn");
      const videoCallBtn = document.getElementById("video-call-btn");
      const endCallBtn = document.getElementById("end-call-btn");
      const startCallBtn = document.getElementById("start-call-btn");

      function updateCallUI() {
        if (!callOverlay) return;
        if (callState === "idle") {
          callOverlay.classList.add("hidden");
          callOverlay.classList.remove("flex");
          if (startCallBtn) {
            startCallBtn.disabled = false;
            startCallBtn.classList.remove("opacity-40");
          }
          return;
        }

        callOverlay.classList.remove("hidden");
        callOverlay.classList.add("flex");

        if (startCallBtn) {
          startCallBtn.disabled = true;
          startCallBtn.classList.add("opacity-40");
        }

        callingCallButtons.classList.add("hidden");
        callingCallButtons.classList.remove("flex");
        incomingCallButtons.classList.add("hidden");
        incomingCallButtons.classList.remove("flex");
        connectedCallButtons.classList.add("hidden");
        connectedCallButtons.classList.remove("flex");

        if (callState === "incoming") {
          callStatusEl.textContent = "Gələn Zəng...";
          incomingCallButtons.classList.remove("hidden");
          incomingCallButtons.classList.add("flex");
        } else if (callState === "calling") {
          callStatusEl.textContent = "Zəng olunur...";
          callingCallButtons.classList.remove("hidden");
          callingCallButtons.classList.add("flex");
        } else if (callState === "connected") {
          callStatusEl.textContent = isVideoOn ? "Görüntülü Əlaqə" : "Canlı Səsli Əlaqə";
          connectedCallButtons.classList.remove("hidden");
          connectedCallButtons.classList.add("flex");
        }

        callNameEl.textContent = incomingCallData?.callerName || "Destək";

        if (isVideoOn) {
          callAudioPlaceholder.classList.add("hidden");
          localVideo.classList.remove("hidden");
        } else {
          callAudioPlaceholder.classList.remove("hidden");
          localVideo.classList.add("hidden");
        }
      }

      function cleanUpCall() {
        try {
          stopRingtone();
          if (localStream) {
            localStream.getTracks().forEach(track => { try { track.stop(); } catch (e) { } });
            localStream = null;
          }
          if (pc) {
            try {
              pc.onicecandidate = null;
              pc.ontrack = null;
              pc.onconnectionstatechange = null;
              pc.oniceconnectionstatechange = null;
              pc.close();
            } catch (e) { }
            pc = null;
          }
          if (remoteVideo) remoteVideo.srcObject = null;
          if (localVideo) localVideo.srcObject = null;

          pendingIceCandidates = [];
          remoteDescriptionSet = false;
          incomingCallData = null;
          callState = "idle";
          isMuted = false;
          isVideoOn = false;
          updateCallUI();
        } catch (error) {
          console.error("Zəng təmizləmə xətası:", error);
        }
      }

      function createPeerConnection(targetRoomId) {
        if (!targetRoomId) throw new Error("Zəng üçün roomId yoxdur.");
        if (pc) { try { pc.close(); } catch (e) { } }

        pc = new RTCPeerConnection(ICE_SERVERS);
        pc.onicecandidate = function (event) {
          if (!event.candidate) return;
          socket.emit("webrtc_ice_candidate", { roomId: targetRoomId, candidate: event.candidate });
        };

        pc.ontrack = function (event) {
          if (remoteVideo && event.streams && event.streams[0]) {
            remoteVideo.srcObject = event.streams[0];
            remoteVideo.play().catch(console.warn);
          }
        };

        pc.onconnectionstatechange = function () {
          if (pc.connectionState === "connected") {
            callState = "connected";
            updateCallUI();
          }
        };

        return pc;
      }

      async function addPendingIceCandidates() {
        if (!pc || !pc.remoteDescription) return;
        const candidates = pendingIceCandidates.slice();
        pendingIceCandidates = [];
        for (const candidate of candidates) {
          try {
            await pc.addIceCandidate(new RTCIceCandidate(candidate));
          } catch (error) {
            console.error("Pending ICE əlavə edilə bilmədi:", error);
          }
        }
      }

      async function startCall() {
        if (!roomId || callState !== "idle") return;
        try {
          initAudioCtx();
          localStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
          pc = createPeerConnection(roomId);
          localStream.getTracks().forEach(track => pc.addTrack(track, localStream));

          const offer = await pc.createOffer({ offerToReceiveAudio: true, offerToReceiveVideo: true });
          await pc.setLocalDescription(offer);

          incomingCallData = Object.assign({}, incomingCallData || {}, { roomId: roomId, offer: pc.localDescription });
          socket.emit("call_user", { roomId: roomId, callerId: userCallId, callerName: userCallName, callerPhoto: userCallPhoto });

          callState = "calling";
          updateCallUI();
          playNotificationSound("outgoing");
        } catch (error) {
          console.error("Zəng başladılarkən xəta:", error);
          cleanUpCall();
        }
      }

      async function acceptCall() {
        if (!incomingCallData) return;
        const targetRoomId = incomingCallData.roomId || roomId;
        if (!targetRoomId) return;

        try {
          localStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
          if (!pc) pc = createPeerConnection(targetRoomId);
          localStream.getTracks().forEach(track => pc.addTrack(track, localStream));

          socket.emit("accept_call", { roomId: targetRoomId, accepterId: userCallId });

          if (incomingCallData.offer) {
            await pc.setRemoteDescription(new RTCSessionDescription(incomingCallData.offer));
            remoteDescriptionSet = true;
            await addPendingIceCandidates();

            const answer = await pc.createAnswer();
            await pc.setLocalDescription(answer);
            socket.emit("webrtc_answer", { roomId: targetRoomId, answer: pc.localDescription });

            callState = "connected";
            updateCallUI();
          } else {
            callState = "calling";
            updateCallUI();
          }
        } catch (error) {
          console.error("Zəng qəbul edilərkən xəta:", error);
          cleanUpCall();
        }
      }

      function rejectCall() {
        const targetRoomId = incomingCallData?.roomId || roomId;
        if (targetRoomId) socket.emit("reject_call", { roomId: targetRoomId, rejecterId: userCallId });
        cleanUpCall();
      }

      function endCall() {
        const targetRoomId = incomingCallData?.roomId || roomId;
        if (targetRoomId) socket.emit("end_call", { roomId: targetRoomId, userId: userCallId });
        cleanUpCall();
      }

      function toggleMute() {
        if (!localStream) return;
        const audioTrack = localStream.getAudioTracks()[0];
        if (!audioTrack) return;
        audioTrack.enabled = !audioTrack.enabled;
        isMuted = !audioTrack.enabled;
        muteCallBtn.textContent = isMuted ? "🔇" : "🎙️";
      }

      async function toggleVideo() {
        if (!localStream) return;
        let videoTrack = localStream.getVideoTracks()[0];
        if (videoTrack) {
          videoTrack.enabled = !videoTrack.enabled;
          isVideoOn = videoTrack.enabled;
          if (isVideoOn && localVideo) {
            localVideo.srcObject = localStream;
            localVideo.classList.remove("hidden");
          } else if (localVideo) {
            localVideo.classList.add("hidden");
          }
          updateCallUI();
          return;
        }

        try {
          const videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
          const newVideoTrack = videoStream.getVideoTracks()[0];
          if (!newVideoTrack) return;

          localStream.addTrack(newVideoTrack);
          if (localVideo) {
            localVideo.srcObject = localStream;
            localVideo.classList.remove("hidden");
          }
          isVideoOn = true;
          updateCallUI();

          if (pc) {
            const sender = pc.getSenders().find(s => s.track && s.track.kind === 'video');
            if (sender) await sender.replaceTrack(newVideoTrack);
            else pc.addTrack(newVideoTrack, localStream);

            const offer = await pc.createOffer();
            await pc.setLocalDescription(offer);
            socket.emit("webrtc_offer", { roomId: roomId, offer: pc.localDescription });
          }
        } catch (error) {
          console.error("Kamera açıla bilmədi:", error);
        }
      }

      if (startCallBtn) startCallBtn.addEventListener("click", startCall);
      if (cancelCallBtn) cancelCallBtn.addEventListener("click", endCall);
      if (acceptCallBtn) acceptCallBtn.addEventListener("click", acceptCall);
      if (rejectCallBtn) rejectCallBtn.addEventListener("click", rejectCall);
      if (muteCallBtn) muteCallBtn.addEventListener("click", toggleMute);
      if (videoCallBtn) videoCallBtn.addEventListener("click", toggleVideo);
      if (endCallBtn) endCallBtn.addEventListener("click", endCall);


      /* ===================================================
         PUSH NOTIFICATIONS & BADGE
      =================================================== */

      const VAPID_PUBLIC_KEY = "BPb6zab3fyTbLclFxSlqt4l82KmqXqpqxrwz2TFJQf1K97xEe9V0cNpM5lSrP2-dzqsdC1CW9G8E7oSFNjAJ9l4";

      function urlBase64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
        const rawData = atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
      }

      if ("serviceWorker" in navigator) {
        window.addEventListener("load", async function () {
          try {
            await navigator.serviceWorker.register("/sw.js");
          } catch (err) { }
        });
      }

      async function initPushNotifications() {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
        try {
          const permission = await Notification.requestPermission();
          if (permission !== "granted") return;
          const registration = await navigator.serviceWorker.ready;
          let subscription = await registration.pushManager.getSubscription();
          if (!subscription) {
            subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
            });
          }
          await fetch(SERVER_URL + "/chatBotApi/api/user/subscribe", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ roomId: roomId, subscription: subscription })
          });
        } catch (err) { }
      }

      let unreadCount = 0;

      function updateBadgeUI() {
        const isChatOpen = !windowEl.classList.contains("hidden");
        if (unreadCount > 0 && !isChatOpen) {
          badgeEl.innerText = unreadCount > 9 ? "9+" : unreadCount;
          badgeEl.classList.remove("hidden");
          badgeEl.classList.add("flex");
          userUnreadBadgeText.innerText = unreadCount + " yeni mesaj";
          userUnreadBadge.classList.remove("hidden");
          userUnreadBadge.classList.add("flex");
        } else {
          badgeEl.classList.remove("flex");
          badgeEl.classList.add("hidden");
          badgeEl.innerText = "0";
          userUnreadBadge.classList.remove("flex");
          userUnreadBadge.classList.add("hidden");
        }
      }

      socket.on("user_update_chat", function (data) {
        if (data.roomId === roomId) {
          unreadCount = data.userUnreadCount || 0;
          updateBadgeUI();
        }
      });


      /* ===================================================
         CATEGORY SELECTION
      =================================================== */

      window.selectCategory = function (category) {
        selectedCategory = category || "jeton";
        localStorage.setItem("chat_category", selectedCategory);
        messagesEl.classList.remove("hidden");
        messagesEl.classList.add("flex");
        formEl.classList.remove("hidden");
        formEl.classList.add("flex");

        socket.emit("join_room", { roomId: roomId, category: selectedCategory });
        socket.emit("mark_all_as_read", { roomId: roomId, reader: "user" });
        loadMessages();
      };

      window.resetCategory = function () {
        selectedCategory = "jeton";
        localStorage.setItem("chat_category", "jeton");
        messagesEl.classList.remove("hidden");
        messagesEl.classList.add("flex");
        formEl.classList.remove("hidden");
        formEl.classList.add("flex");
      };

      function checkCategoryState() {
        if (!selectedCategory) {
          selectedCategory = "jeton";
          localStorage.setItem("chat_category", "jeton");
        }

        messagesEl.classList.remove("hidden");
        messagesEl.classList.add("flex");
        formEl.classList.remove("hidden");
        formEl.classList.add("flex");
      }


      /* ===================================================
         LOAD MESSAGES & RENDER
      =================================================== */

      let isShowingFavorites = false;

      function loadMessages(callback) {
        if (messagesEl) {
          messagesEl.innerHTML = "";
          if (!isShowingFavorites) {
            // İlk salam dərhal görünür; backend cavabından sonra ya hamısı statik,
            // ya da typing animasiyası ilə davam etdirilir.
            ensureInChatWelcome({ animate: true });
          }
        }

        fetch(SERVER_URL + "/chatBotApi/api/messages/users/" + encodeURIComponent(roomId) + "?role=user", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        })
          .then(res => res.json())
          .then(messages => {
            const validMessages = Array.isArray(messages)
              ? messages.filter(m => !(m.deletedFor && m.deletedFor.includes("user")))
              : [];
            const filtered = isShowingFavorites
              ? validMessages.filter(m => m.favoritedBy && m.favoritedBy.includes(roomId))
              : validMessages;

            // Backend-də real mesaj varsa welcome mesajları dərhal və animasiyasız göstərilir.
            // Real mesaj yoxdursa salam artıq görünür və qalan welcome mesajları typing effekti ilə gəlir.
            if (messagesEl) {
              Array.from(messagesEl.children).forEach(function (child) {
                if (child.id !== "local-chat-welcome-message") {
                  child.remove();
                }
              });
            }

            if (!isShowingFavorites) {
              const welcome = document.getElementById("local-chat-welcome-message");
              if (filtered.length > 0) {
                showWelcomeStatic(welcome);
              } else {
                startWelcomeAnimation(welcome);
              }
            }

            if (filtered.length === 0 && isShowingFavorites) {
              messagesEl.innerHTML = '<div class="text-center text-xs text-slate-400 py-6 font-medium">Bu söhbətdə favori mesaj yoxdur.</div>';
            } else {
              filtered.forEach(function (message) {
                appendMessage(Object.assign({}, message, {
                  adminPhoto: message.adminPhoto || null,
                  photo: message.photo || (message.sender === "user" ? getCurrentUserPhoto() : "")
                }));
              });
            }

            const unreadAdminMsgs = validMessages.filter(m => m.sender === "admin" && !m.isReadByUser);
            unreadCount = unreadAdminMsgs.length;
            updateBadgeUI();

            if (callback) callback();
          })
          .catch(console.error);
      }
          /* ===================================================
   DATE SEPARATOR
=================================================== */

function getDateSeparatorKey(timestamp) {
  const date = new Date(timestamp || Date.now());

  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0")
  );
}



function formatDateSeparator(timestamp) {
  const date = new Date(timestamp || Date.now());
  const now = new Date();

  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  const messageDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  const diffDays = Math.floor(
    (today - messageDay) / (24 * 60 * 60 * 1000)
  );

  if (diffDays === 0) {
    return "BUGÜN";
  }

  if (diffDays === 1) {
    return "DÜNƏN";
  }

  const months = [
    "YANVAR",
    "FEVRAL",
    "MART",
    "APREL",
    "MAY",
    "İYUN",
    "İYUL",
    "AVQUST",
    "SENTYABR",
    "OKTYABR",
    "NOYABR",
    "DEKABR"
  ];

  return (
    String(date.getDate()).padStart(2, "0") +
    " " +
    months[date.getMonth()] +
    " " +
    date.getFullYear()
  );
}


    

      /* ===================================================
   APPEND MESSAGE
   YENİ CHAT DESIGN + DATE SEPARATOR
=================================================== */

function appendMessage(msg) {
  const msgId =
    msg._id ||
    msg.id ||
    ("msg_" + Math.random().toString(36).substring(2, 9));

  if (
    msg.deletedFor &&
    msg.deletedFor.includes("user")
  ) {
    return;
  }

  if (document.getElementById(msgId)) {
    updateMessageInDOM(msgId, msg);
    return;
  }

  const isFav =
    msg.favoritedBy &&
    msg.favoritedBy.includes(roomId);

  if (
    isShowingFavorites &&
    !isFav
  ) {
    return;
  }

  const messageTimestamp =
    msg.timestamp || Date.now();

  /* ===================================================
     DATE SEPARATOR
  =================================================== */

  const dateKey =
    getDateSeparatorKey(messageTimestamp);

  const separatorId =
    "date-separator-" + dateKey;

  if (
    !document.getElementById(separatorId)
  ) {
    const separator =
      document.createElement("div");

    separator.id = separatorId;

    separator.className =
      "w-full flex items-center justify-center my-5 select-none";

    separator.innerHTML =
      '<div class="flex items-center gap-3 w-full max-w-[300px]">' +

        '<div class="h-px flex-1 bg-slate-200 dark:bg-slate-700"></div>' +

        '<span class="px-3 py-1 rounded-full ' +
          'bg-slate-100 dark:bg-slate-800 ' +
          'border border-slate-200 dark:border-slate-700 ' +
          'text-[9px] font-bold tracking-wider ' +
          'text-slate-500 dark:text-slate-400">' +

          formatDateSeparator(
            messageTimestamp
          ) +

        "</span>" +

        '<div class="h-px flex-1 bg-slate-200 dark:bg-slate-700"></div>' +

      "</div>";

    messagesEl.appendChild(
      separator
    );
  }


  /* ===================================================
     MESSAGE CONTAINER
  =================================================== */

  const div =
    document.createElement("div");

  div.id = msgId;

  div.setAttribute(
    "data-sender",
    msg.sender
  );

  div.setAttribute(
    "data-message-id",
    msgId
  );

  div.className =
    "w-full my-1.5 flex flex-col " +
    "message-bubble-container group " +
    "items-" +
    (
      msg.sender === "user"
        ? "end"
        : "start"
    );


  /* ===================================================
     DELETED MESSAGE
  =================================================== */

  if (msg.isDeleted) {

    div.innerHTML =
      '<div class="text-[11px] italic ' +
        'text-slate-500 dark:text-slate-400 ' +
        'bg-slate-200/60 dark:bg-slate-800 ' +
        'py-1.5 px-3 rounded-xl ' +
        'border border-slate-200 dark:border-slate-700 ' +
        'max-w-[80%]">' +

        "🗑️ Bu mesaj silindi" +

      "</div>";

    messagesEl.appendChild(div);

    messagesEl.scrollTop =
      messagesEl.scrollHeight;

    return;
  }


  /* ===================================================
     AUDIO / IMAGE
  =================================================== */

  const isAudio =
    msg.messageType === "audio" ||
    (
      msg.text &&
      (
        /\.(webm|ogg|wav|mp3|m4a|mp4)$/i.test(
          msg.text
        ) ||
        msg.text.includes("/audios/")
      )
    );

  const isImage =
    !isAudio &&
    (
      msg.messageType === "image" ||
      (
        msg.text &&
        (
          /\.(jpeg|jpg|gif|png|webp)$/i.test(
            msg.text
          ) ||
          msg.text.includes("/categories/") ||
          msg.text.includes("/uploads/")
        )
      )
    );


  let messageContent =
    msg.text || "";


  /* ===================================================
     AUDIO
  =================================================== */

if (isAudio) {

  /*
   * isPlayed:
   * false = hələ dinlənilməyib
   * true  = artıq dinlənilib
   */

  const playedClass = msg.isPlayed
    ? "text-blue-500 dark:text-emerald-400"
    : "text-slate-400 dark:text-slate-500";

  const buttonClass = msg.isPlayed
    ? "bg-blue-500 hover:bg-blue-600 dark:bg-emerald-600 dark:hover:bg-emerald-500"
    : "bg-slate-400 hover:bg-slate-500 dark:bg-slate-600 dark:hover:bg-slate-500";

  messageContent =
    '<div class="whatsapp-audio flex items-center gap-2 ' +
      'min-w-[210px] max-w-[250px] px-2.5 py-2 ' +
      'bg-slate-100 dark:bg-slate-700/90 ' +
      'rounded-2xl border border-slate-200/70 ' +
      'dark:border-slate-600/70 shadow-sm">' +

      /* PLAY BUTTON */
      '<button type="button" ' +
        'class="audio-play-btn shrink-0 w-9 h-9 ' +
        'rounded-full flex items-center justify-center ' +
        buttonClass +
        ' text-white shadow-sm transition-colors" ' +

        'onclick="window.toggleChatAudio(\'' +
          msgId +
        '\')">' +

        '<span class="audio-play-icon text-[15px]">▶</span>' +

      '</button>' +

      /* AUDIO BODY */
      '<div class="flex-1 min-w-0 flex flex-col gap-1">' +

        '<div class="audio-progress-wrap relative w-full h-5 ' +
          'flex items-center cursor-pointer touch-none select-none" ' +
          'onmousedown="window.startChatAudioSeek(event, \'' +
            msgId +
          '\')" ' +
          'ontouchstart="window.startChatAudioSeek(event, \'' +
            msgId +
          '\')">' +

          '<div class="absolute left-0 right-0 h-1.5 ' +
            'rounded-full bg-slate-300 dark:bg-slate-600">' +
          '</div>' +

          '<div class="audio-progress absolute left-0 h-1.5 ' +
            'rounded-full ' +
            (msg.isPlayed
              ? "bg-blue-500 dark:bg-emerald-400"
              : "bg-slate-400 dark:bg-slate-500") +
            '" style="width:0%">' +
          '</div>' +

          '<div class="audio-progress-dot absolute w-2.5 h-2.5 ' +
            'rounded-full shadow-sm left-0 -translate-x-1/2 ' +
            (msg.isPlayed
              ? "bg-blue-500 dark:bg-emerald-400"
              : "bg-slate-400 dark:bg-slate-500") +
            '">' +
          '</div>' +

        '</div>' +

        '<div class="flex items-center justify-end ' +
          'text-[9px] leading-none ' +
          'font-medium ' +
          playedClass +
          '">' +

          '<span class="audio-current-time">0:00</span>' +
          '<span class="opacity-50">/</span>' +
          '<span class="audio-duration"></span>' +

        '</div>' +

      '</div>' +

      /*
       * REAL AUDIO
       * Görünmür, amma playback üçün istifadə olunur.
       */
'<audio id="audio-' +
  msgId +
  '" ' +
  'src="' + escapeHtml(msg.text) + '" ' +
  'preload="metadata" ' +
  'class="hidden" ' +

  /* Səs sahibini audio elementində saxlayırıq */
  'data-sender="' + escapeHtml(msg.sender || "") + '" ' +

  /* isPlayed başlanğıc vəziyyəti */
  'data-played="' + (msg.isPlayed ? "true" : "false") + '" ' +

  'onplay="window.handleAudioPlay(\'' +
    msgId +
  '\', \'' +
    msg.sender +
  '\', ' +
    Boolean(msg.isPlayed) +
  ')" ' +

  'onloadedmetadata="window.initChatAudio(\'' +
    msgId +
  '\')" ' +

  'ontimeupdate="window.updateChatAudio(\'' +
    msgId +
  '\')" ' +

  'onended="window.resetChatAudio(\'' +
    msgId +
  '\')">' +

'</audio>'
 +

    '</div>';

}



  /* ===================================================
     IMAGE
  =================================================== */

  else if (isImage) {

    messageContent =
      '<div class="p-0.5">' +

        '<img src="' +
          escapeHtml(msg.text) +
          '" alt="Photo" ' +

          'class="rounded-xl max-w-full max-h-48 ' +
          'object-cover block border ' +
          'border-slate-200/60 dark:border-slate-700/60 ' +
          'cursor-pointer" ' +

          'onclick="window.openImage(\'' +
            escapeHtml(msg.text) +
          '\')">' +

      "</div>";
  }


  /* ===================================================
     REPLY
  =================================================== */

  let replyMarkup = "";

  if (msg.replyTo) {

    const replyTargetId =
      typeof msg.replyTo === "object"
        ? (
            msg.replyTo._id ||
            msg.replyTo.id
          )
        : msg.replyTo;

    const replySender =
      typeof msg.replyTo === "object"
        ? msg.replyTo.sender
        : "admin";

    const replyText =
      typeof msg.replyTo === "object"
        ? (
            msg.replyTo.text ||
            "Fayl/Şəkil"
          )
        : "Mesaj";



window.chatAudioSeeking = null;

window.setChatAudioPosition = function (msgId, clientX) {
  const audio = document.getElementById("audio-" + msgId);
  if (!audio || !Number.isFinite(audio.duration) || audio.duration <= 0) return;

  const container = audio.closest(".whatsapp-audio");
  if (!container) return;

  const track = container.querySelector(".audio-progress-wrap");
  if (!track) return;

  const rect = track.getBoundingClientRect();
  if (!rect.width) return;

  let percent = ((clientX - rect.left) / rect.width) * 100;
  percent = Math.max(0, Math.min(100, percent));

  audio.currentTime = (percent / 100) * audio.duration;

  const progress = container.querySelector(".audio-progress");
  const dot = container.querySelector(".audio-progress-dot");
  const currentTime = container.querySelector(".audio-current-time");

  if (progress) progress.style.width = percent + "%";
  if (dot) dot.style.left = percent + "%";

  if (currentTime) {
    const minutes = Math.floor(audio.currentTime / 60);
    const seconds = Math.floor(audio.currentTime % 60).toString().padStart(2, "0");
    currentTime.textContent = minutes + ":" + seconds;
  }
};

window.startChatAudioSeek = function (event, msgId) {
  event.preventDefault();
  event.stopPropagation();

  const getClientX = function (e) {
    if (e.touches && e.touches.length) return e.touches[0].clientX;
    if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
    return e.clientX;
  };

  const audio = document.getElementById("audio-" + msgId);
  if (!audio || !Number.isFinite(audio.duration) || audio.duration <= 0) return;

  window.chatAudioSeeking = msgId;
  window.setChatAudioPosition(msgId, getClientX(event));

  const move = function (e) {
    if (window.chatAudioSeeking !== msgId) return;
    e.preventDefault();
    window.setChatAudioPosition(msgId, getClientX(e));
  };

  const end = function () {
    if (window.chatAudioSeeking === msgId) window.chatAudioSeeking = null;
    document.removeEventListener("mousemove", move);
    document.removeEventListener("mouseup", end);
    document.removeEventListener("touchmove", move, { passive: false });
    document.removeEventListener("touchend", end);
    document.removeEventListener("touchcancel", end);
  };

  document.addEventListener("mousemove", move);
  document.addEventListener("mouseup", end);
  document.addEventListener("touchmove", move, { passive: false });
  document.addEventListener("touchend", end);
  document.addEventListener("touchcancel", end);
};

window.toggleChatAudio = function (msgId) {

  const audio =
    document.getElementById("audio-" + msgId);

  if (!audio) return;

  const container =
    audio.closest(".whatsapp-audio");

  if (!container) return;

  const button =
    container.querySelector(".audio-play-btn");

  const icon =
    container.querySelector(".audio-play-icon");

  const progress =
    container.querySelector(".audio-progress");

  const dot =
    container.querySelector(".audio-progress-dot");

  /*
   * Səsin sahibi
   */
  const sender =
    audio.dataset.sender || "";

  const isAdminAudio =
    sender === "admin";

  /*
   * PLAY
   */
  if (audio.paused) {

    /*
     * ==========================================
     * ADMIN AUDIO
     * ==========================================
     */
    if (
      isAdminAudio &&
      audio.dataset.played !== "true"
    ) {

      console.log(
        "🔊 ADMIN AUDIO FIRST PLAY:",
        msgId
      );

      /*
       * Lokal olaraq played qeyd et.
       */
      audio.dataset.played = "true";
      audio.dataset.isPlayed = "true";

      /*
       * Backend
       */
      if (
        typeof socket !== "undefined" &&
        socket &&
        socket.connected
      ) {

        console.log(
          "📤 play_audio:",
          {
            roomId,
            messageId: msgId
          }
        );

        socket.emit(
          "play_audio",
          {
            roomId: roomId,
            messageId: msgId
          }
        );
      }

      /*
       * ADMIN rəngi:
       *
       * Light -> blue
       * Dark  -> green
       */
      if (button) {

        button.classList.remove(
          "bg-slate-400",
          "hover:bg-slate-500",
          "dark:bg-slate-600",
          "dark:hover:bg-slate-500"
        );

        button.classList.add(
          "bg-blue-500",
          "hover:bg-blue-600",
          "dark:bg-emerald-600",
          "dark:hover:bg-emerald-500"
        );
      }

      if (progress) {

        progress.classList.remove(
          "bg-slate-400",
          "dark:bg-slate-500"
        );

        progress.classList.add(
          "bg-blue-500",
          "dark:bg-emerald-400"
        );
      }

      if (dot) {

        dot.classList.remove(
          "bg-slate-400",
          "dark:bg-slate-500"
        );

        dot.classList.add(
          "bg-blue-500",
          "dark:bg-emerald-400"
        );
      }
    }

    /*
     * ==========================================
     * USER-IN ÖZ SƏSİ
     * ==========================================
     *
     * Burada heç bir dəyişiklik etmirik.
     *
     * ❌ socket.emit yoxdur
     * ❌ dataset.played dəyişmir
     * ❌ rəng dəyişmir
     * ❌ isPlayed true olmur
     */

    audio.play().catch(function (err) {

      console.warn(
        "Audio play error:",
        err
      );

    });

    if (button) {
      button.classList.add("playing");
    }

    if (icon) {

      icon.textContent = "❚❚";

      icon.classList.add(
        "text-[11px]"
      );
    }

  }

  /*
   * PAUSE
   */
  else {

    audio.pause();

    if (button) {
      button.classList.remove("playing");
    }

    if (icon) {

      icon.textContent = "▶";

      icon.classList.remove(
        "text-[11px]"
      );
    }
  }
};





window.initChatAudio = function (msgId) {

  const audio =
    document.getElementById(
      "audio-" + msgId
    );

  if (!audio) return;

  const container =
    audio.closest(".whatsapp-audio");

  if (!container) return;

  const durationEl =
    container.querySelector(
      ".audio-duration"
    );

  if (!durationEl) return;

  if (
    Number.isFinite(audio.duration) &&
    audio.duration > 0
  ) {

    const minutes =
      Math.floor(audio.duration / 60);

    const seconds =
      Math.floor(audio.duration % 60)
        .toString()
        .padStart(2, "0");

    durationEl.textContent =
      minutes + ":" + seconds;
  }
};


window.updateChatAudio = function (msgId) {

  const audio =
    document.getElementById(
      "audio-" + msgId
    );

  if (!audio) return;

  const container =
    audio.closest(".whatsapp-audio");

  if (!container) return;

  const progress =
    container.querySelector(
      ".audio-progress"
    );

  const dot =
    container.querySelector(
      ".audio-progress-dot"
    );

  const currentTime =
    container.querySelector(
      ".audio-current-time"
    );

  if (!audio.duration) return;

  const percent =
    (audio.currentTime / audio.duration) * 100;

  if (progress) {
    progress.style.width =
      percent + "%";
  }

  if (dot) {
    dot.style.left =
      percent + "%";
  }

  if (currentTime) {

    const minutes =
      Math.floor(audio.currentTime / 60);

    const seconds =
      Math.floor(audio.currentTime % 60)
        .toString()
        .padStart(2, "0");

    currentTime.textContent =
      minutes + ":" + seconds;
  }
};


window.resetChatAudio = function (msgId) {

  const audio =
    document.getElementById(
      "audio-" + msgId
    );

  if (!audio) return;

  const container =
    audio.closest(".whatsapp-audio");

  if (!container) return;

  const icon =
    container.querySelector(
      ".audio-play-icon"
    );

  const progress =
    container.querySelector(
      ".audio-progress"
    );

  const dot =
    container.querySelector(
      ".audio-progress-dot"
    );

  const currentTime =
    container.querySelector(
      ".audio-current-time"
    );

  if (icon) {
    icon.textContent = "▶";
    icon.classList.remove("text-[11px]");
  }

  if (progress) {
    progress.style.width = "0%";
  }

  if (dot) {
    dot.style.left = "0%";
  }

  if (currentTime) {
    currentTime.textContent = "0:00";
  }
};


    const replyBorderColor =
      msg.sender === "user"
        ? "border-l-violet-300 bg-violet-900/30"
        : "border-l-violet-500 bg-slate-100/80 dark:bg-slate-700/60";

    const replyTitleColor =
      msg.sender === "user"
        ? "text-violet-100"
        : "text-violet-600 dark:text-violet-300";

    const replyTextColor =
      msg.sender === "user"
        ? "text-violet-100"
        : "text-slate-600 dark:text-slate-300";


    replyMarkup =
      '<div ' +
        'onclick="window.scrollToMessage(\'' +
          replyTargetId +
        '\')" ' +

        'class="text-[11px] p-1.5 px-2 ' +
        'rounded-lg border-l-2 ' +
        replyBorderColor +
        ' mb-1.5 opacity-95 max-w-full ' +
        'truncate cursor-pointer">' +

        '<div class="font-bold text-[10px] ' +
          replyTitleColor +
        '">' +

          (
            replySender === "user"
              ? "Siz"
              : "Destək Ekibi"
          ) +

        "</div>" +

        '<div class="truncate ' +
          replyTextColor +
          ' text-[11px]">' +

          escapeHtml(replyText) +

        "</div>" +

      "</div>";
  }


  /* ===================================================
     MESSAGE STATUS
     
     ✔  = göndərildi
     ✔✔ = çatdırıldı
     ✔✔ = oxundu

     READ:
     Light = ağ
     Dark  = yaşıl

     DELIVERED:
     Light = boz
     Dark  = boz
  =================================================== */

  let statusTicks = "";

  if (msg.sender === "user") {

    /*
     * VACİB:
     * isPlayed artıq READ hesab olunmur.
     */

    const isRead =
      msg.status === "read" ||
      msg.isRead ||
      msg.isReadByAdmin;

    const isDelivered =
      msg.status === "delivered" ||
      msg.isDelivered ||
      isRead;


    if (isRead) {

  statusTicks =
    '<span class="tick-status ' +
      'text-blue-500 dark:text-emerald-400 ' +
      'inline-flex items-center ml-1">' +

      '<svg viewBox="0 0 24 16" width="16" height="11" ' +
        'fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +

        '<path d="M1 8l4 4L13 3"/>' +
        '<path d="M9 8l4 4L21 3"/>' +

      '</svg>' +

    '</span>';

}

   else if (isDelivered) {

  statusTicks =
    '<span class="tick-status ' +
      'text-slate-300 dark:text-slate-500 ' +
      'inline-flex items-center ml-1">' +

      '<svg viewBox="0 0 24 16" width="16" height="11" ' +
        'fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +

        '<path d="M1 8l4 4L13 3"/>' +
        '<path d="M9 8l4 4L21 3"/>' +

      '</svg>' +

    '</span>';

}

 else {

  statusTicks =
    '<span class="tick-status ' +
      'text-slate-300 dark:text-slate-500 ' +
      'inline-flex items-center ml-1">' +

      '<svg viewBox="0 0 12 10" width="12" height="10" ' +
        'fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +

        '<path d="M1 5l3 3L11 1"/>' +

      '</svg>' +

    '</span>';
}
  }


  /* ===================================================
     NEW BUBBLE COLORS
  =================================================== */

 const bubbleBg =
  msg.sender === "user"

    ? "bg-emerald-500 dark:bg-emerald-700 " +
      "text-white rounded-2xl rounded-tr-md " +
      "shadow-sm"

    : "bg-slate-100 dark:bg-slate-800 " +
      "text-slate-800 dark:text-slate-100 " +
      "border border-slate-200 dark:border-slate-700 " +
      "rounded-2xl rounded-tl-md shadow-sm";


  const padding =
    (isImage || isAudio)
      ? "p-1"
      : "py-2 px-3.5";


  /* ===================================================
     REACTIONS
  =================================================== */

  let reactionsMarkup =
    '<div class="reactions-bar flex items-center ' +
    'gap-1 mt-0.5 px-1 empty:hidden">';


  if (
    msg.reactions &&
    Object.keys(msg.reactions).length > 0
  ) {

    Object.entries(
      msg.reactions
    ).forEach(
      ([emoji, count]) => {

        if (count > 0) {

          reactionsMarkup +=
            '<span class="bg-white dark:bg-slate-700 ' +
            'border border-slate-200 dark:border-slate-600 ' +
            'text-[10px] px-1.5 py-0.5 rounded-full ' +
            'shadow-xs text-slate-700 dark:text-slate-200 ' +
            'font-bold">' +

              escapeHtml(emoji) +
              " " +
              count +

            "</span>";
        }
      }
    );
  }

  reactionsMarkup += "</div>";


  /* ===================================================
     FAVORITE
  =================================================== */

  const clickAttr =
    isShowingFavorites

      ? 'onclick="window.scrollToMessage(\'' +
        msgId +
        '\')"'

      : "";


  const favRedirectHint =
    isShowingFavorites

      ? '<div class="mt-1 pt-1 ' +
        'border-t border-white/20 ' +
        'text-[10px] text-amber-200 ' +
        'font-medium flex items-center gap-1">' +
          "💬 Sohbətdə göstər" +
        "</div>"

      : "";


  /* ===================================================
     MESSAGE AVATAR
  =================================================== */
  const senderPhoto = msg.sender === "user"
    ? (msg.photo || msg.userInfo?.photo || getCurrentUserPhoto() || "")
    : (msg.adminPhoto || msg.photo || "");

  const avatarMarkup = senderPhoto
    ? '<img src="' + escapeHtml(senderPhoto) + '" alt="" class="w-full h-full object-cover">'
    : (msg.sender === "admin" ? '<span class="text-sm">👨‍💼</span>' : '<span class="text-sm">👤</span>');
  const avatar = '<div class="message-avatar w-7 h-7 rounded-full shrink-0 overflow-hidden bg-slate-200 dark:bg-slate-700 text-slate-500 dark:text-slate-300 flex items-center justify-center border border-white/80 dark:border-slate-600 shadow-sm transition-transform duration-200 group-hover:scale-105">' + avatarMarkup + '</div>';

  /* ===================================================
     FINAL MESSAGE
  =================================================== */

  div.innerHTML =

    '<div class="flex items-center gap-1.5 ' +
      'w-full ' +

      (
        msg.sender === "user"
          ? "flex-row-reverse"
          : "flex-row"
      ) +

      ' max-w-[94%]">' +


      avatar +


      '<div ' +
        clickAttr +
        ' class="' +

        bubbleBg +
        " " +
        padding +

        ' text-[13px] font-normal leading-relaxed ' +
        'break-words relative flex flex-col ' +
        'min-w-0 ' +

        (
          isShowingFavorites
            ? "cursor-pointer hover:opacity-90"
            : ""
        ) +

      '">' +


        replyMarkup +


        '<div class="text-content select-text cursor-text">' +

          (
            isAudio || isImage
              ? messageContent
              : escapeHtml(msg.text || "")
          ) +

        "</div>" +


        /* TIME + STATUS */

        '<div class="text-[9px] text-right mt-1 ' +
          'opacity-80 flex justify-end items-center ' +
          'gap-1 select-none font-medium">' +


          '<span class="fav-star-icon ' +
            'text-amber-300 font-bold">' +

            (
              isFav
                ? "⭐"
                : ""
            ) +

          "</span>" +


          '<span class="edited-lbl italic ' +
            (
              msg.isEdited
                ? ""
                : "hidden"
            ) +
          '">' +

            "(düzenlendi)" +

          "</span>" +


          '<span>' +

            new Date(
              messageTimestamp
            ).toLocaleTimeString(
              [],
              {
                hour: "2-digit",
                minute: "2-digit"
              }
            ) +

          "</span>" +


          statusTicks +


        "</div>" +


        favRedirectHint +


      "</div>" +


      /* ACTION MENU */

'<div class="action-trigger flex items-center ' +
  'gap-0.5 transition-opacity duration-150 ' +
  'shrink-0 select-none">' +

  '<button type="button" ' +

    'onclick="window.openActionMenu(event, \'' +
      msgId +
    '\', \'' +
      msg.sender +
    '\', \'' +
      encodeURIComponent(msg.text || "") +
    '\', ' +
      Boolean(isFav) +
    ')" ' +

    'class="text-slate-400 ' +
    'hover:text-slate-600 ' +
    'dark:hover:text-slate-300 ' +
    'hover:bg-slate-200/60 ' +
    'dark:hover:bg-slate-700 ' +
    'p-1.5 rounded-lg ' +
    'border border-slate-200/50 ' +
    'dark:border-slate-700 ' +
    'bg-white dark:bg-slate-800 ' +
    'cursor-pointer transition-colors ' +
    'shadow-xs">⋮</button>' +

'</div>'
 +


    "</div>" +


    reactionsMarkup;


  messagesEl.appendChild(div);

  messagesEl.scrollTop =
    messagesEl.scrollHeight;
}
      function escapeHtml(value) {
        return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }

      function updateMessageInDOM(msgId, msg) {
        const el = document.getElementById(msgId);
        if (!el) return;

        if (msg.deleteType === "me" || (msg.deletedFor && msg.deletedFor.includes("user"))) {
          el.remove();
          return;
        }

        const isFav = msg.favoritedBy && msg.favoritedBy.includes(roomId);
        const starEl = el.querySelector(".fav-star-icon");
        if (starEl) starEl.innerText = isFav ? "⭐" : "";

        if (isShowingFavorites && !isFav) {
          el.remove();
          return;
        }

        const textContentEl = el.querySelector(".text-content");
        if (textContentEl && msg.newText !== undefined) {
          textContentEl.innerText = msg.newText;
        }

        const editedLbl = el.querySelector(".edited-lbl");
        if (editedLbl && (msg.isEdited || msg.newText !== undefined)) {
          editedLbl.classList.remove("hidden");
        }
      }


window.handleAudioPlay = function (
  messageId,
  sender,
  isAlreadyPlayed
) {

  initAudioCtx();

  /*
   * YALNIZ ADMIN SƏSİ
   */
  if (
    sender === "admin" &&
    !isAlreadyPlayed
  ) {

    console.log(
      "🔊 Marking admin audio as played:",
      messageId
    );

    if (
      typeof socket !== "undefined" &&
      socket &&
      socket.connected
    ) {

      console.log(
        "📤 EMITTING play_audio:",
        {
          roomId,
          messageId
        }
      );

      socket.emit(
        "play_audio",
        {
          roomId: roomId,
          messageId: messageId
        },
        function (response) {

          console.log(
            "📥 play_audio ACK:",
            response
          );

        }
      );
    }

    /*
     * Backend-ə göndərdikdən sonra
     * həmin audio üçün lokal olaraq played saxla.
     */
    const audio = document.getElementById(
      "audio-" + messageId
    );

    if (audio) {
      audio.dataset.played = "true";
      audio.dataset.isPlayed = "true";
    }
  }

  /*
   * USER-IN ÖZ SƏSİ
   *
   * Heç nə etmirik.
   *
   * ❌ socket.emit yoxdur
   * ❌ isPlayed true edilmir
   * ❌ rəng dəyişmir
   */
};





      window.toggleFavoriteMessage = function (messageId) {
        socket.emit("toggle_favorite", { messageId: messageId, entityId: roomId });
      };

      window.toggleShowFavorites = function () {
        isShowingFavorites = !isShowingFavorites;
        const favBtnText = document.getElementById("fav-btn-text");
        if (favBtnText) favBtnText.innerText = isShowingFavorites ? "Bütün" : "Favorilər";
        loadMessages();
      };

      const favToggle = document.getElementById("chat-widget-fav-toggle");
      if (favToggle) favToggle.addEventListener("click", window.toggleShowFavorites);

      let replyingToMessageId = null;
      let editingMessageId = null;

      window.triggerReply = function (messageId, encodedText) {
        const text = decodeURIComponent(encodedText);
        replyingToMessageId = messageId;
        editingMessageId = null;
        const parentMsg = document.getElementById(messageId);
        const sender = parentMsg ? parentMsg.getAttribute("data-sender") : "admin";
        replyTitle.innerText = sender === "user" ? "Siz" : "Destək Ekibi";
        replyTextEl.innerText = text || "Fayl/Şəkil";
        replyContainer.classList.remove("hidden");
        replyContainer.classList.add("flex");
        inputEl.focus();
      };

      if (replyCancelBtn) {
        replyCancelBtn.addEventListener("click", function () {
          replyingToMessageId = null;
          replyContainer.classList.remove("flex");
          replyContainer.classList.add("hidden");
        });
      }

      window.triggerEdit = function (messageId, encodedText) {
        const text = decodeURIComponent(encodedText);
        editingMessageId = messageId;
        replyingToMessageId = null;
        replyContainer.classList.remove("flex");
        replyContainer.classList.add("hidden");
        inputEl.value = text;
        submitBtnEl.innerHTML = "✓";
        inputEl.focus();
      };

      window.copyMessage = async function (encodedText) {
        const text = decodeURIComponent(encodedText);
        try {
          let copied = false;

          if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            try {
              await navigator.clipboard.writeText(text);
              copied = true;
            } catch (clipboardError) {
              copied = false;
            }
          }

          if (!copied) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            textarea.style.pointerEvents = "none";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);
            copied = document.execCommand("copy");
            textarea.remove();
          }

          if (!copied) {
            throw new Error("copy_failed");
          }

          const old = document.getElementById("chat-copy-toast");
          if (old) old.remove();
          const toast = document.createElement("div");
          toast.id = "chat-copy-toast";
          toast.className = "fixed bottom-24 left-1/2 -translate-x-1/2 bg-slate-900 text-white text-xs px-4 py-2 rounded-xl shadow-2xl z-[99999999]";
          toast.innerText = "📋 Mesaj kopyalandı";
          document.body.appendChild(toast);
          setTimeout(() => toast.remove(), 1800);
        } catch (error) {
          alert("Mesaj kopyalana bilmədi.");
        }
      };

      window.executeDelete = function (messageId, deleteType) {
        const target = document.getElementById(messageId);
        if (target) target.remove();
        socket.emit("delete_message", { roomId: roomId, messageId: messageId, deleteType: deleteType });
      };

      window.openActionMenu = function (event, messageId, sender, encodedText, isFav) {
        event.stopPropagation();
        event.preventDefault();
        const text = decodeURIComponent(encodedText);
        const oldMenu = document.getElementById("chat-widget-context-menu");
        if (oldMenu) oldMenu.remove();

        const menu = document.createElement("div");
        menu.id = "chat-widget-context-menu";
        menu.className = "fixed bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl py-1.5 z-[2000000] text-xs text-slate-700 dark:text-slate-200 w-44 font-sans font-medium";

        const clientX = event.clientX || window.innerWidth / 2;
        const clientY = event.clientY || window.innerHeight / 2;
        let leftPos = Math.max(15, Math.min(clientX, window.innerWidth - 176 - 15));
        let topPos = Math.max(15, Math.min(clientY, window.innerHeight - 200 - 15));

        menu.style.top = topPos + "px";
        menu.style.left = leftPos + "px";

        let menuItems =
          '<button type="button" onclick="window.toggleFavoriteMessage(\'' + messageId + '\')" class="w-full text-left px-3.5 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center gap-2 cursor-pointer text-amber-600 font-semibold">' + (isFav ? "★ Favoridən Çıxar" : "⭐ Favorilərə Əlavə Et") + "</button>" +
          '<button type="button" onclick="window.triggerReply(\'' + messageId + "', \`" + encodeURIComponent(text) + '\`)" class="w-full text-left px-3.5 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center gap-2 cursor-pointer">↩ Yanıtla</button>' +
          '<button type="button" onclick="window.copyMessage(\`' + encodeURIComponent(text) + '\`)" class="w-full text-left px-3.5 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center gap-2 cursor-pointer">📋 Mesajı Kopyala</button>';

        if (sender === "user") {
          menuItems += '<button type="button" onclick="window.triggerEdit(\'' + messageId + "', \`" + encodeURIComponent(text) + '\`)" class="w-full text-left px-3.5 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center gap-2 cursor-pointer">✏️ Düzenle</button>';
        }

        menuItems += '<button type="button" onclick="window.executeDelete(\'' + messageId + "', 'me')" + '" class="w-full text-left px-3.5 py-2 text-rose-500 hover:bg-rose-50 flex items-center gap-2 cursor-pointer">🗑️ Özündən Sil</button>';

        menu.innerHTML = menuItems;
        document.body.appendChild(menu);

        setTimeout(() => {
          document.addEventListener("click", function closeMenu() {
            if (menu) menu.remove();
            document.removeEventListener("click", closeMenu);
          });
        }, 10);
      };

      window.addInstantReaction = function (messageId, reaction) {
        socket.emit("send_reaction", { roomId: roomId, messageId: messageId, reaction: reaction, sender: "user" });
      };

      window.scrollToMessage = function (messageId) {
        if (!messageId) return;
        const performScroll = function () {
          const target = document.getElementById(messageId);
          if (!target) return;
          target.scrollIntoView({ behavior: "smooth", block: "center" });
          target.classList.add("highlight-target");
          setTimeout(() => target.classList.remove("highlight-target"), 2000);
        };

        if (isShowingFavorites) {
          isShowingFavorites = false;
          loadMessages(() => setTimeout(performScroll, 100));
        } else {
          performScroll();
        }
      };


      /* ===================================================
         IMAGE VIEWER
      =================================================== */

      window.openImage = function (src) {
        document.getElementById("imageViewerImg").src = src;
        document.getElementById("imageViewer").classList.remove("hidden");
        document.getElementById("imageViewer").classList.add("flex");
        document.body.style.overflow = "hidden";
      };

      window.closeImage = function () {
        document.getElementById("imageViewer").classList.add("hidden");
        document.getElementById("imageViewer").classList.remove("flex");
        document.body.style.overflow = "";
      };

      const closeImgBtn = document.getElementById("close-image-btn");
      if (closeImgBtn) closeImgBtn.addEventListener("click", window.closeImage);

      const imgViewer = document.getElementById("imageViewer");
      if (imgViewer) {
        imgViewer.addEventListener("click", function (e) {
          if (e.target.id === "imageViewer") window.closeImage();
        });
      }


      /* ===================================================
         ADMIN STATUS & ODAYA DAXİL OLMASI
      =================================================== */
    let adminOnline = false;
let adminLastSeen = null;
let adminLastSeenInterval = null;

function formatAdminLastSeen(lastSeen) {
  if (!lastSeen) return "";

  const timestamp = new Date(lastSeen).getTime();

  if (Number.isNaN(timestamp)) {
    return "";
  }

  const diff = Date.now() - timestamp;

  // 1 dəqiqədən az
  if (diff < 60 * 1000) {
    return "1 dəq əvvəl online idi";
  }

  // 1-5 dəqiqə
  if (diff < 5 * 60 * 1000) {
    const minutes = Math.floor(diff / (60 * 1000));

    return String(minutes) + " dəq əvvəl online idi";
  }

  const date = new Date(timestamp);

  const time = date.toLocaleTimeString("az-AZ", {
    hour: "2-digit",
    minute: "2-digit"
  });

  // 5 dəqiqədən 24 saata qədər
  if (diff < 24 * 60 * 60 * 1000) {
    return "Son görülmə " + time;
  }

  // 1 gündən sonra
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return (
    "Son görülmə " +
    time +
    " " +
    day +
    "." +
    month +
    "." +
    year
  );
}

function updateAdminStatusUI(isAdminOnline, lastSeen) {
  adminOnline = Boolean(isAdminOnline);

  if (lastSeen) {
    adminLastSeen = lastSeen;
  }

  if (!adminDotEl || !adminTextEl) return;

  if (adminOnline) {
    adminDotEl.className =
      "w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.7)] shrink-0";

    adminTextEl.innerText = "Onlayn";

    adminTextEl.className =
      "text-[11px] font-semibold text-emerald-600 dark:text-emerald-400";

    updateAdminActivityUI("");

  } else {
    adminDotEl.className =
      "w-2 h-2 rounded-full bg-slate-400 shrink-0";

    adminTextEl.innerText = "Offline";

    adminTextEl.className =
      "text-[11px] font-semibold text-slate-500 dark:text-slate-400";

    updateAdminActivityUI(
      formatAdminLastSeen(adminLastSeen)
    );
  }

  if (adminLastSeenInterval) {
    clearInterval(adminLastSeenInterval);
    adminLastSeenInterval = null;
  }

  if (!adminOnline && adminLastSeen) {
    adminLastSeenInterval = setInterval(function () {
      if (!adminOnline && adminLastSeen) {
        updateAdminActivityUI(
          formatAdminLastSeen(adminLastSeen)
        );
      }
    }, 30000);
  }
}

      function updateAdminActivityUI(status) {
        if (!adminActivityEl) return;
        if (adminActivityTimeout) {
          clearTimeout(adminActivityTimeout);
          adminActivityTimeout = null;
        }

        const text = String(status || "").trim();
        if (!text) {
          adminActivityEl.textContent = "";
          adminActivityEl.classList.add("hidden");
          return;
        }

        adminActivityEl.textContent = text;
        adminActivityEl.classList.remove("hidden");
        adminActivityEl.className = "text-[11px] font-medium text-slate-400 dark:text-slate-500 truncate";
      }


      /* ===================================================
         MARK ALL USER MESSAGES AS READ (2 MAVİ CHECK LOGİCİ)
      =================================================== */

     /* ===================================================
   MARK ALL USER MESSAGES AS READ
   LIGHT = WHITE
   DARK  = GREEN
=================================================== */

function markAllUserMessagesAsReadUI() {
  const userMessages =
    messagesEl.querySelectorAll(
      '[data-sender="user"]'
    );

  userMessages.forEach(
    function (el) {

      const tickEl =
        el.querySelector(
          ".tick-status"
        );

      if (tickEl) {

        tickEl.innerHTML =
          '<svg viewBox="0 0 24 16" width="16" height="11" ' +
            'fill="none" stroke="currentColor" ' +
            'stroke-width="2.2" stroke-linecap="round" ' +
            'stroke-linejoin="round">' +
            '<path d="M1 8l4 4L13 3"/>' +
            '<path d="M9 8l4 4L21 3"/>' +
          '</svg>';

        tickEl.className =
          "tick-status " +
          "text-blue-500 dark:text-emerald-400 " +
          "inline-flex items-center ml-1";
      }
    }
  );
}
        function markAllUserMessagesAsDeliveredUI() {
  const userMessages =
    messagesEl.querySelectorAll('[data-sender="user"]');

  userMessages.forEach(function (el) {

    const tickEl =
      el.querySelector(".tick-status");

    if (!tickEl) return;

    /*
     * Artıq oxunubsa dəyişmə.
     * Oxunmuş = light mavi / dark yaşıl
     */
    if (
      tickEl.className.includes("text-blue-500") ||
      tickEl.className.includes("dark:text-emerald-400")
    ) {
      return;
    }

    tickEl.innerHTML =
      '<svg viewBox="0 0 24 16" width="16" height="11" ' +
        'fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" ' +
        'stroke-linejoin="round">' +
        '<path d="M1 8l4 4L13 3"/>' +
        '<path d="M9 8l4 4L21 3"/>' +
      '</svg>';

    tickEl.className =
      "tick-status " +
      "text-slate-300 dark:text-slate-500 " +
      "inline-flex items-center ml-1";
  });
}

socket.on("admin_messages_delivered", function (data) {
  if (!data) return;

  const eventCategory = String(
    data.category || ""
  ).toLowerCase().trim();

  const myCategory = String(
    selectedCategory || ""
  ).toLowerCase().trim();

  if (
    eventCategory &&
    myCategory &&
    eventCategory !== myCategory
  ) {
    return;
  }

  markAllUserMessagesAsDeliveredUI();
});


      /* ===================================================
         SOCKET CONNECT
      =================================================== */

      socket.on("connect", function () {
        console.log("Socket connected:", socket.id);

        if (selectedCategory) {
          socket.emit("join_room", { roomId: roomId, category: selectedCategory });
          const isChatOpen = !windowEl.classList.contains("hidden");
          socket.emit("user_active_status", { roomId: roomId, isActive: isChatOpen, category: selectedCategory });
        }

        fetch(SERVER_URL + "/chatBotApi/api/chats", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        })
          .then(res => res.json())
          .then(chats => {
            const currentRoom = chats.find(c => c.roomId === roomId);
           if (currentRoom) {
  updateAdminStatusUI(
    currentRoom.isAdminOnline,
    currentRoom.adminLastSeen || null
  );
}
          })
          .catch(console.error);

        loadMessages();
        initPushNotifications();
      });

      socket.on("admin_messages_delivered", function (data) {
  if (!data) return;

  const eventCategory = String(
    data.category || ""
  ).toLowerCase().trim();

  const myCategory = String(
    selectedCategory || ""
  ).toLowerCase().trim();

  if (
    eventCategory &&
    myCategory &&
    eventCategory !== myCategory
  ) {
    return;
  }

  markAllUserMessagesAsDeliveredUI();
});


      /* ===================================================
         SOCKET EVENTS & ADMIN ODAYA GIRDI LOGIC
      =================================================== */

      socket.on("favorite_updated", function (data) {
        if (data.roomId === roomId) loadMessages();
      });

      // Admin spesifik bu chat odasına girdikdə trigger olur
      socket.on("admin_joined_room", function (data) {
        if (!data || data.roomId === roomId) {
          updateAdminStatusUI(true);
          updateAdminActivityUI("Admin odaya daxil oldu");
          adminActivityTimeout = setTimeout(() => updateAdminActivityUI(""), 4000);

          // Admin odaya girdisə göndərilən mesajları cüt göy xətt et
          markAllUserMessagesAsReadUI();
        }
      });

      socket.on("admin_online_status", function (data) {
        if (data.roomId === roomId) {
          updateAdminStatusUI(data.isAdminOnline);
        }
      });

    socket.on("admin_global_status", function (data) {
  if (!data) return;

  const eventCategory = String(
    data.category || ""
  ).toLowerCase().trim();

  const myCategory = String(
    selectedCategory || ""
  ).toLowerCase().trim();

  if (
    eventCategory &&
    myCategory &&
    eventCategory !== myCategory
  ) {
    return;
  }

  updateAdminStatusUI(
    Boolean(data.isAdminOnline),
    data.lastSeen || null
  );
});

      socket.on("message_edited", function (data) {
        if (data.roomId === roomId) updateMessageInDOM(data.messageId, data);
      });

      socket.on("message_deleted", function (data) {
        if (data.roomId !== roomId) return;
        const target = document.getElementById(data.messageId);
        if (data.deleteType === "me") {
          if (target) target.remove();
        } else {
          updateMessageInDOM(data.messageId, data);
        }
      });


      /* ===================================================
         CALL SOCKET EVENTS
      =================================================== */

      socket.on("incoming_call", function (data) {
        incomingCallData = Object.assign({}, incomingCallData || {}, data);
        callState = "incoming";
        updateCallUI();
        playNotificationSound("incoming");
        playRingtone();
      });

      socket.on("call_accepted", async function (data) {
        if (!data || !data.roomId) return;
        if (pc && pc.localDescription && pc.localDescription.type === "offer") {
          try {
            socket.emit("webrtc_offer", { roomId: data.roomId, offer: pc.localDescription });
          } catch (error) {
            console.error("Offer göndərilərkən xəta:", error);
          }
        }
      });

      socket.on("webrtc_offer", async function (data) {
        if (!data || !data.roomId || !data.offer) return;
        incomingCallData = Object.assign({}, incomingCallData || {}, { roomId: data.roomId, offer: data.offer });

        if (callState === "incoming") return;

        if (pc && (callState === "connected" || callState === "calling")) {
          try {
            await pc.setRemoteDescription(new RTCSessionDescription(data.offer));
            remoteDescriptionSet = true;
            await addPendingIceCandidates();
            const answer = await pc.createAnswer();
            await pc.setLocalDescription(answer);
            socket.emit("webrtc_answer", { roomId: data.roomId, answer: pc.localDescription });
            callState = "connected";
            updateCallUI();
          } catch (error) {
            console.error("OFFER tətbiq edilərkən xəta:", error);
          }
        }
      });

socket.on("audio_marked_as_played", ({ roomId: dataRoomId, messageId, isPlayed }) => {
  // Otaq kontrolu (əgər roomId gəlirsə)
  if (typeof roomId !== "undefined" && dataRoomId && dataRoomId !== roomId) return;

  // Audio elementi "audio-MESSAGE_ID" formatındadır
  const audio = document.getElementById("audio-" + messageId);
  if (!audio) return;

  // Dataset-i yeniləyirik
  audio.dataset.played = "true";
  audio.dataset.isPlayed = "true";

  // Valideyn WhatsApp Audio konteynerini tapırıq
  const container = audio.closest(".whatsapp-audio");
  if (!container) return;

  const button = container.querySelector(".audio-play-btn");
  const progress = container.querySelector(".audio-progress");
  const dot = container.querySelector(".audio-progress-dot");
  const timeContainer = container.querySelector(".audio-duration")?.parentElement;

  // Button Rəngi (Light: Göy, Dark: Yaşıl)
  if (button) {
    button.classList.remove(
      "bg-slate-400", "hover:bg-slate-500",
      "dark:bg-slate-600", "dark:hover:bg-slate-500"
    );
    button.classList.add(
      "bg-blue-500", "hover:bg-blue-600",
      "dark:bg-emerald-600", "dark:hover:bg-emerald-500"
    );
  }

  // Progress Bar Rəngi
  if (progress) {
    progress.classList.remove("bg-slate-400", "dark:bg-slate-500");
    progress.classList.add("bg-blue-500", "dark:bg-emerald-400");
  }

  // Progress Dot Rəngi
  if (dot) {
    dot.classList.remove("bg-slate-400", "dark:bg-slate-500");
    dot.classList.add("bg-blue-500", "dark:bg-emerald-400");
  }

  // Vaxt / Status mətni rəngi
  if (timeContainer) {
    timeContainer.classList.remove("text-slate-400", "dark:text-slate-500");
    timeContainer.classList.add("text-blue-500", "dark:text-emerald-400");
  }

  // Bildiriş səsi çalmaq istəsəniz:
  if (typeof playNotificationSound === "function") {
    playNotificationSound("played");
  }
});


      socket.on("webrtc_answer", async function (data) {
        if (!data || !data.answer || !pc) return;
        try {
          await pc.setRemoteDescription(new RTCSessionDescription(data.answer));
          remoteDescriptionSet = true;
          await addPendingIceCandidates();
          callState = "connected";
          updateCallUI();
        } catch (error) {
          console.error("ANSWER tətbiq edilərkən xəta:", error);
        }
      });

      socket.on("webrtc_ice_candidate", async function (data) {
        if (!data || !data.candidate) return;
        if (!pc || !pc.remoteDescription) {
          pendingIceCandidates.push(data.candidate);
          return;
        }
        try {
          await pc.addIceCandidate(new RTCIceCandidate(data.candidate));
        } catch (error) {
          console.error("ICE candidate əlavə xətası:", error);
        }
      });

      socket.on("call_rejected", function () {
        alert("Zəng rədd edildi.");
        cleanUpCall();
      });

      socket.on("call_ended", function () {
        cleanUpCall();
      });

      socket.on("reaction_updated", function (data) {
        if (data.roomId === roomId) loadMessages();
      });

     


      /* ===================================================
         RECEIVE MESSAGE & READ SYSTEM
      =================================================== */

      socket.on("receive_message", function (data) {
        if (!data) return;
        if (data.roomId && data.roomId !== roomId) return;

        if (isShowingFavorites) isShowingFavorites = false;

        appendMessage(Object.assign({}, data, {
          adminPhoto: data.adminPhoto || null,
          photo: data.photo || (data.sender === "user" ? getCurrentUserPhoto() : "")
        }));

        if (data.sender === "admin") {
          if (data.messageType === "audio") {
            updateAdminActivityUI("🎙️ Səs göndərdi");
          } else if (data.messageType === "image") {
            updateAdminActivityUI("🖼️ Şəkil göndərdi");
          } else {
            updateAdminActivityUI("");
          }

          if (data.messageType === "audio" || data.messageType === "image") {
            adminActivityTimeout = setTimeout(() => updateAdminActivityUI(""), 3500);
          }
        }

        if (data.sender === "admin") {
          playNotificationSound("incoming");
          const isWindowOpen = !windowEl.classList.contains("hidden");
          if (isWindowOpen) {
            socket.emit("mark_all_as_read", { roomId: roomId, reader: "user" });
          } else {
            unreadCount++;
            updateBadgeUI();
          }
        }
      });

      // Admin istifadəçinin mesajlarını oxuduqda və ya odaya girdikdə trigger olan event
      socket.on("messages_marked_as_read", function ({ roomId: id, reader }) {
        if (id !== roomId) return;

        if (reader === "admin") {
          markAllUserMessagesAsReadUI();
          playNotificationSound("read");
        }
      });


      /* ===================================================
         TYPING & RINGTONE
      =================================================== */

      let typingTimeout = null;

      inputEl.addEventListener("input", function () {
        if (editingMessageId) return;

        socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "Yazır..." });

        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(() => {
          socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "" });
        }, 2000);
      });

      socket.on("user_typing_status", function (data) {
        if (data.roomId !== roomId) return;
        const activityStatus = data.status || "";
        if (data.sender === "admin" || data.sender === "system" || !data.sender) {
          updateAdminActivityUI(activityStatus);
        }
        typingIndicatorEl.textContent = "";
        typingIndicatorEl.classList.add("hidden");
      });

      const ringtone = new Audio("https://assets.mixkit.co/active_storage/sfx/1359/1359-preview.mp3");
      ringtone.loop = true;

      function playRingtone() {
        ringtone.currentTime = 0;
        ringtone.play().catch(console.warn);
      }

      function stopRingtone() {
        ringtone.pause();
        ringtone.currentTime = 0;
      }

      if (acceptCallBtn) acceptCallBtn.addEventListener("click", stopRingtone);
      if (rejectCallBtn) rejectCallBtn.addEventListener("click", function () {
        stopRingtone();
        socket.emit("reject_call", { roomId: roomId });
      });

      socket.on("call_cancelled", function () {
        stopRingtone();
      });


      /* ===================================================
         CHAT WINDOW TOGGLE
      =================================================== */

      function closeChatWindow() {
        const welcome = document.getElementById("local-chat-welcome-message");
        if (welcome) welcome.remove();

        windowEl.classList.remove("flex");
        windowEl.classList.add("hidden");
        socket.emit("user_active_status", { roomId: roomId, isActive: false });
        updateBadgeUI();
      }

      toggleBtn.addEventListener("click", function () {
        initAudioCtx();
        const isHidden = windowEl.classList.contains("hidden");

        if (isHidden) {
          checkCategoryState();
          windowEl.classList.remove("hidden");
          windowEl.classList.add("flex");

          const chatCallout = document.getElementById("chat-widget-callout");
          if (chatCallout) {
            chatCallout.classList.add("hidden");
            chatCallout.classList.remove("flex");
          }

          if (!selectedCategory) {
            selectedCategory = "jeton";
            localStorage.setItem("chat_category", "jeton");
          }

          socket.emit("join_room", { roomId: roomId, category: selectedCategory });
          socket.emit("user_active_status", { roomId: roomId, isActive: true, category: selectedCategory });
          socket.emit("mark_all_as_read", { roomId: roomId, reader: "user" });
          loadMessages();

          unreadCount = 0;
          updateBadgeUI();

          setTimeout(() => { messagesEl.scrollTop = messagesEl.scrollHeight; }, 50);
        } else {
          closeChatWindow();
          window.refreshChatWelcome();
        }
      });

      if (closeMobileBtn) {
        closeMobileBtn.addEventListener("click", function () {
          closeChatWindow();
          window.refreshChatWelcome();
        });
      }


      /* ===================================================
         FILE PREVIEW & VOICE RECORDING
      =================================================== */

      let selectedFile = null;

      fileBtnEl.addEventListener("click", () => fileInputEl.click());

      fileInputEl.addEventListener("change", function (e) {
        const file = e.target.files[0];
        if (!file) return;

        selectedFile = file;
        previewImg.src = URL.createObjectURL(file);
        previewName.innerText = file.name;

        previewContainer.classList.remove("hidden");
        previewContainer.classList.add("flex");
        inputEl.placeholder = "Açıklama ekleyin...";

        socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "Fotoğraf seçir..." });
      });

      function clearImageSelection() {
        if (previewImg.src && previewImg.src.startsWith("blob:")) {
          URL.revokeObjectURL(previewImg.src);
        }
        selectedFile = null;
        fileInputEl.value = "";
        previewImg.src = "";
        previewName.innerText = "";
        previewContainer.classList.remove("flex");
        previewContainer.classList.add("hidden");
        inputEl.placeholder = "Mesajınızı yazın...";

        socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "" });
      }

      cancelBtn.addEventListener("click", clearImageSelection);

      let mediaRecorder = null;
      let audioChunks = [];
      let recordingInterval = null;
      let recordingDuration = 0;
      let audioStream = null;

      function startTimer() {
        recordingInterval = setInterval(function () {
          recordingDuration++;
          const mins = Math.floor(recordingDuration / 60).toString().padStart(2, "0");
          const secs = (recordingDuration % 60).toString().padStart(2, "0");
          voiceTimerEl.innerText = mins + ":" + secs;
        }, 1000);
      }

      function stopTimer() {
        clearInterval(recordingInterval);
      }
    async function uploadAndSendAudio(
        audioBlob
      ) {

        try {

          submitBtnEl.disabled =
            true;

          voiceBtnEl.disabled =
            true;

          fileBtnEl.disabled =
            true;


          const formData =
            new FormData();


          formData.append(
            "audio",
            audioBlob,
            "voice-recording.webm"
          );


          const response =
            await fetch(
              SERVER_URL +
              "/chatBotApi/api/upload-audio",
              {
                method: "POST",
                body: formData
              }
            );


          if (!response.ok) {

            throw new Error(
              "Ses yüklənmədi"
            );

          }


          const data =
            await response.json();


          if (data.url) {

            socket.emit(
              "send_message",
              {
                roomId: roomId,
                sender: "user",
                text: data.url,
                messageType: "audio",
                 photo: getCurrentUserPhoto(),
                category:
                  selectedCategory,
                replyTo:
                  replyingToMessageId
              }
            );

            markUserHasSentMessage();

          }


          replyingToMessageId =
            null;


          replyContainer.classList.remove(
            "flex"
          );

          replyContainer.classList.add(
            "hidden"
          );


        } catch (error) {

          console.error(error);

          alert(
            "Ses göndərilə bilmədi."
          );


        } finally {

          submitBtnEl.disabled =
            false;

          voiceBtnEl.disabled =
            false;

          fileBtnEl.disabled =
            false;

        }

      }


  formEl.addEventListener(
        "submit",
        async function (e) {

          e.preventDefault();


          if (
            mediaRecorder &&
            mediaRecorder.state !==
            "inactive"
          ) {

            mediaRecorder.onstop =
              async function () {

                if (audioStream) {

                  audioStream
                    .getTracks()
                    .forEach(
                      function (track) {
                        track.stop();
                      }
                    );

                }


                if (
                  audioChunks.length > 0
                ) {

                  const blob =
                    new Blob(
                      audioChunks,
                      {
                        type:
                          mediaRecorder.mimeType
                      }
                    );


                  await uploadAndSendAudio(
                    blob
                  );

                }


                audioChunks = [];

                resetVoiceUI();

              };


            mediaRecorder.stop();

            return;

          }


          const textValue =
            inputEl.value.trim();


          if (
            !textValue &&
            !selectedFile
          ) {
            return;
          }

          let didSendUserMessage = false;


          /* EDIT */

          if (editingMessageId) {

            if (textValue) {

              socket.emit(
                "edit_message",
                {
                  roomId: roomId,
                  messageId:
                    editingMessageId,
                  newText:
                    textValue
                }
              );

            }


            editingMessageId =
              null;


            inputEl.value =
              "";


            submitBtnEl.innerHTML =
              "➤";


            return;

          }


          try {

            submitBtnEl.disabled =
              true;

            fileBtnEl.disabled =
              true;

            voiceBtnEl.disabled =
              true;


            /* IMAGE */

            if (selectedFile) {

              const formData =
                new FormData();


              formData.append(
                "photo",
                selectedFile
              );


              const response =
                await fetch(
                  SERVER_URL +
                  "/chatBotApi/api/upload",
                  {
                    method: "POST",
                    body: formData
                  }
                );


              if (!response.ok) {

                throw new Error(
                  "Şəkil yüklənmədi"
                );

              }


              const data =
                await response.json();


              if (data.url) {

                socket.emit(
                  "send_message",
                  {
                    roomId: roomId,
                    sender: "user",
                    text: data.url,
                    messageType: "image",
                 photo: getCurrentUserPhoto(),
                    category:
                      selectedCategory,
                    replyTo:
                      replyingToMessageId
                  }
                );

                didSendUserMessage = true;

              }


              clearImageSelection();

            }


            /* TEXT */

            if (textValue) {

              socket.emit(
                "send_message",
                {
                  roomId: roomId,
                  sender: "user",
                  text: textValue,
                  messageType: "text",
                 photo: getCurrentUserPhoto(),
                  category:
                    selectedCategory,
                  replyTo:
                    replyingToMessageId
                }
              );

              didSendUserMessage = true;


              inputEl.value =
                "";

            }


            replyingToMessageId =
              null;


            replyContainer.classList.remove(
              "flex"
            );

            replyContainer.classList.add(
              "hidden"
            );


            socket.emit(
              "client_typing_status",
              {
                roomId: roomId,
                sender: "user",
                status: ""
              }
            );

            if (didSendUserMessage) {
              markUserHasSentMessage();
            }


          } catch (error) {

            console.error(error);

            alert(
              "Mesaj göndərilə bilmədi."
            );


          } finally {

            submitBtnEl.disabled =
              false;

            fileBtnEl.disabled =
              false;

            voiceBtnEl.disabled =
              false;

          }

        }
      );

function resetVoiceUI() {
        if (audioStream) {
          audioStream.getTracks().forEach(track => track.stop());
          audioStream = null;
        }
        stopTimer();
        recordingDuration = 0;
        voiceContainer.classList.remove("flex");
        voiceContainer.classList.add("hidden");
        voiceBtnIcon.innerText = "🎙️";
        inputEl.disabled = false;
        inputEl.placeholder = "Mesajınızı yazın...";

        socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "" });
      }

      voiceBtnEl.addEventListener("click", async function () {
        initAudioCtx();

        if (!mediaRecorder || mediaRecorder.state === "inactive") {
          try {
            audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
            audioChunks = [];
            recordingDuration = 0;
            voiceTimerEl.innerText = "00:00";

            let options = { mimeType: "audio/webm" };
            if (!MediaRecorder.isTypeSupported("audio/webm")) {
              options = { mimeType: "audio/ogg" };
            }

            mediaRecorder = new MediaRecorder(audioStream, options);
            mediaRecorder.ondataavailable = function (e) {
              if (e.data.size > 0) audioChunks.push(e.data);
            };

            mediaRecorder.start();
            voiceBtnIcon.innerText = "⏸️";
            voiceContainer.classList.remove("hidden");
            voiceContainer.classList.add("flex");
            voicePing.classList.add("animate-ping");
            voiceWaves.classList.remove("opacity-30");
            inputEl.disabled = true;
            inputEl.placeholder = "Ses kaydedilir...";

            startTimer();
            socket.emit("client_typing_status", { roomId: roomId, sender: "user", status: "Ses kaydedilir..." });
          } catch (err) {
            alert("Ses yazmaq üçün mikrofon icazəsi lazımdır.");
          }
        } else if (mediaRecorder.state === "recording") {
          mediaRecorder.pause();
          stopTimer();
          voiceBtnIcon.innerText = "▶️";
          voicePing.classList.remove("animate-ping");
          voiceWaves.classList.add("opacity-30");
        } else if (mediaRecorder.state === "paused") {
          mediaRecorder.resume();
          startTimer();
          voiceBtnIcon.innerText = "⏸️";
          voicePing.classList.add("animate-ping");
          voiceWaves.classList.remove("opacity-30");
        }
      });

      voiceCancelBtn.addEventListener("click", function () {
        if (mediaRecorder && mediaRecorder.state !== "inactive") {
          mediaRecorder.stop();
        }
        audioChunks = [];
        resetVoiceUI();
      });


      /* ===================================================
         CHAT WIDGET DRAG & POSITION
         - Mouse + touch + pen
         - Mövqe localStorage-da saxlanılır
         - Ekrandan kənara çıxmasına icazə verilmir
         - Drag-dan sonra chat toggle click-i bloklanır
      =================================================== */

      const CHAT_POSITION_STORAGE_KEY = "chat_widget_position_v1";

      let chatDragState = {
        active: false,
        moved: false,
        startX: 0,
        startY: 0,
        startLeft: 0,
        startTop: 0,
        pointerId: null,
      };

      let suppressNextChatClick = false;

      function getChatWidgetElements() {
        return {
          container: document.getElementById("chat-widget-container"),
          button: document.getElementById("chat-widget-toggle"),
        };
      }

      function clampChatPosition(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function saveChatWidgetPosition(left, top) {
        try {
          localStorage.setItem(
            CHAT_POSITION_STORAGE_KEY,
            JSON.stringify({
              left,
              top,
            })
          );
        } catch (error) {
          console.warn("Chat widget position save error:", error);
        }
      }

      function loadChatWidgetPosition() {
        try {
          const saved = localStorage.getItem(CHAT_POSITION_STORAGE_KEY);

          if (!saved) return null;

          const parsed = JSON.parse(saved);

          if (
            typeof parsed.left !== "number" ||
            typeof parsed.top !== "number" ||
            !Number.isFinite(parsed.left) ||
            !Number.isFinite(parsed.top)
          ) {
            return null;
          }

          return parsed;
        } catch (error) {
          console.warn("Chat widget position load error:", error);
          return null;
        }
      }

      function setChatWidgetPosition(left, top, shouldSave = true) {
        const { container } = getChatWidgetElements();

        if (!container) return;

        const rect = container.getBoundingClientRect();

        const maxLeft = Math.max(
          0,
          window.innerWidth - rect.width
        );

        const maxTop = Math.max(
          0,
          window.innerHeight - rect.height
        );

        const safeLeft = clampChatPosition(left, 0, maxLeft);
        const safeTop = clampChatPosition(top, 0, maxTop);

        container.style.left = safeLeft + "px";
        container.style.top = safeTop + "px";
        container.style.right = "auto";
        container.style.bottom = "auto";

        if (shouldSave) {
          saveChatWidgetPosition(safeLeft, safeTop);
        }
      }

      function restoreChatWidgetPosition() {
        const { container } = getChatWidgetElements();

        if (!container) return;

        const saved = loadChatWidgetPosition();

        requestAnimationFrame(() => {
          const currentContainer = document.getElementById(
            "chat-widget-container"
          );

          if (!currentContainer) return;

          if (saved) {
            setChatWidgetPosition(
              saved.left,
              saved.top,
              false
            );
            return;
          }

          const rect = currentContainer.getBoundingClientRect();

          const defaultLeft = 16;
          const defaultTop =
            window.innerHeight - rect.height - 48;

          setChatWidgetPosition(
            defaultLeft,
            Math.max(16, defaultTop),
            false
          );
        });
      }

      function startChatWidgetDrag(event) {
        const { container, button } = getChatWidgetElements();

        if (!container || !button) return;

        // Yalnız əsas mouse düyməsi.
        if (
          event.pointerType === "mouse" &&
          event.button !== 0
        ) {
          return;
        }

        const rect = container.getBoundingClientRect();

        chatDragState = {
          active: true,
          moved: false,
          startX: event.clientX,
          startY: event.clientY,
          startLeft: rect.left,
          startTop: rect.top,
          pointerId: event.pointerId,
        };

        try {
          button.setPointerCapture?.(event.pointerId);
        } catch (error) {}

        button.style.cursor = "grabbing";
        button.style.transition = "none";

        event.preventDefault();
      }

      function moveChatWidgetDrag(event) {
        if (!chatDragState.active) return;

        if (
          chatDragState.pointerId !== null &&
          event.pointerId !== chatDragState.pointerId
        ) {
          return;
        }

        const { container } = getChatWidgetElements();

        if (!container) return;

        const deltaX =
          event.clientX - chatDragState.startX;

        const deltaY =
          event.clientY - chatDragState.startY;

        // 4px-dən kiçik hərəkəti click kimi saxla.
        if (
          Math.abs(deltaX) > 4 ||
          Math.abs(deltaY) > 4
        ) {
          chatDragState.moved = true;
        }

        if (!chatDragState.moved) return;

        const rect = container.getBoundingClientRect();

        const maxLeft = Math.max(
          0,
          window.innerWidth - rect.width
        );

        const maxTop = Math.max(
          0,
          window.innerHeight - rect.height
        );

        const newLeft = clampChatPosition(
          chatDragState.startLeft + deltaX,
          0,
          maxLeft
        );

        const newTop = clampChatPosition(
          chatDragState.startTop + deltaY,
          0,
          maxTop
        );

        container.style.left = newLeft + "px";
        container.style.top = newTop + "px";
        container.style.right = "auto";
        container.style.bottom = "auto";

        event.preventDefault();
      }

      function endChatWidgetDrag(event) {
        if (!chatDragState.active) return;

        const { button, container } =
          getChatWidgetElements();

        if (button) {
          button.style.cursor = "grab";
          button.style.transition = "";
        }

        if (chatDragState.moved) {
          suppressNextChatClick = true;

          const rect =
            container?.getBoundingClientRect();

          if (rect) {
            saveChatWidgetPosition(
              rect.left,
              rect.top
            );
          }

          // Pointer hadisəsindən sonra yaranan click-i blokla.
          setTimeout(() => {
            suppressNextChatClick = false;
          }, 100);
        }

        try {
          if (
            button &&
            chatDragState.pointerId !== null &&
            button.hasPointerCapture?.(
              chatDragState.pointerId
            )
          ) {
            button.releasePointerCapture(
              chatDragState.pointerId
            );
          }
        } catch (error) {}

        chatDragState.active = false;
        chatDragState.pointerId = null;

        if (event) {
          event.preventDefault();
        }
      }

      function setupChatWidgetDrag() {
        const { button } = getChatWidgetElements();

        if (!button) return;

        // Mobil cihazlarda pointer hərəkəti browser scroll-a çevrilməsin.
        button.style.touchAction = "none";
        button.style.cursor = "grab";

        button.addEventListener(
          "pointerdown",
          startChatWidgetDrag,
          { passive: false }
        );

        button.addEventListener(
          "pointermove",
          moveChatWidgetDrag,
          { passive: false }
        );

        button.addEventListener(
          "pointerup",
          endChatWidgetDrag,
          { passive: false }
        );

        button.addEventListener(
          "pointercancel",
          endChatWidgetDrag,
          { passive: false }
        );

        // Drag etdikdən sonra toggle funksiyası işləməsin.
        button.addEventListener(
          "click",
          function (event) {
            if (suppressNextChatClick) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation?.();
              suppressNextChatClick = false;
            }
          },
          true
        );

        // Native HTML drag davranışını söndür.
        button.addEventListener(
          "dragstart",
          function (event) {
            event.preventDefault();
          }
        );

        restoreChatWidgetPosition();
      }

      function keepChatWidgetInsideScreen() {
        const { container } =
          getChatWidgetElements();

        if (!container) return;

        const rect =
          container.getBoundingClientRect();

        const maxLeft = Math.max(
          0,
          window.innerWidth - rect.width
        );

        const maxTop = Math.max(
          0,
          window.innerHeight - rect.height
        );

        const currentLeft = parseFloat(
          container.style.left
        );

        const currentTop = parseFloat(
          container.style.top
        );

        if (
          Number.isNaN(currentLeft) ||
          Number.isNaN(currentTop)
        ) {
          return;
        }

        const newLeft = clampChatPosition(
          currentLeft,
          0,
          maxLeft
        );

        const newTop = clampChatPosition(
          currentTop,
          0,
          maxTop
        );

        container.style.left = newLeft + "px";
        container.style.top = newTop + "px";
        container.style.right = "auto";
        container.style.bottom = "auto";

        saveChatWidgetPosition(
          newLeft,
          newTop
        );
      }

      // Digər kodlardan da mövqeni sıfırlamaq üçün istifadə oluna bilər.
      window.resetChatWidgetPosition = function () {
        try {
          localStorage.removeItem(
            CHAT_POSITION_STORAGE_KEY
          );
        } catch (error) {}

        const { container } =
          getChatWidgetElements();

        if (!container) return;

        const rect =
          container.getBoundingClientRect();

        const left = 16;

        const top = Math.max(
          16,
          window.innerHeight -
            rect.height -
            48
        );

        setChatWidgetPosition(
          left,
          top,
          false
        );
      };

      setupChatWidgetDrag();

      window.addEventListener(
        "resize",
        keepChatWidgetInsideScreen,
        { passive: true }
      );

    })();
`;





const CHAT_MARKUP = String.raw`
<style>
  @keyframes chatCalloutFloat {
    0%, 100% { transform: translateY(0) scale(1); }
    50% { transform: translateY(-3px) scale(1.02); }
  }

  @keyframes chatCalloutGlow {
    0%, 100% { box-shadow: 0 8px 25px rgba(15,23,42,0.12); }
    50% { box-shadow: 0 10px 32px rgba(79,70,229,0.24); }
  }

  @keyframes chatTogglePulse {
    0%, 100% { transform: scale(1); opacity: .45; }
    50% { transform: scale(1.16); opacity: 0; }
  }

  .chat-widget-callout-animated {
    animation: chatCalloutFloat 2.2s ease-in-out infinite,
               chatCalloutGlow 2.2s ease-in-out infinite;
    transform-origin: bottom left;
  }

  .chat-widget-toggle-premium {
    isolation: isolate;
    filter: drop-shadow(0 12px 24px rgba(79,70,229,0.18));
  }

  .chat-toggle-ring {
    position: absolute;
    inset: 0;
    border-radius: 1.15rem;
    border: 1px solid rgba(129,140,248,.42);
    pointer-events: none;
    z-index: 0;
  }

  .chat-toggle-ring-1 {
    animation: chatTogglePulse 2.4s ease-out infinite;
  }

  .chat-toggle-ring-2 {
    animation: chatTogglePulse 2.4s ease-out infinite .8s;
  }

  #local-chat-welcome-message .welcome-line {
    will-change: transform, opacity;
  }
</style>

<div
  id="chat-widget-container"
  class="fixed z-[999999] select-none antialiased font-sans flex flex-col items-start gap-2"
  style="left:16px; bottom:48px;"
>

  <!-- UNREAD BADGE -->
  <div
    id="userUnreadBadge"
    class="hidden items-center gap-1.5 bg-gradient-to-r from-rose-600 to-pink-600 text-white font-bold text-[10px] px-3 py-1.5 rounded-full shadow-[0_8px_25px_rgba(225,29,72,0.25)] border border-white/20"
  >
    <span class="relative flex w-1.5 h-1.5">
      <span class="absolute inline-flex h-full w-full rounded-full bg-white opacity-75 animate-ping"></span>
      <span class="relative inline-flex rounded-full w-1.5 h-1.5 bg-white"></span>
    </span>

    <span id="userUnreadBadgeText">0 yeni mesaj</span>
  </div>


  <!-- SMALL CALLOUT -->
  <div
    id="chat-widget-callout"
    class="relative flex items-center justify-center
           bg-white/95 dark:bg-slate-900/95
           backdrop-blur-xl
           text-slate-700 dark:text-slate-200
           px-3 py-1.5
           rounded-xl
           border border-slate-200/80 dark:border-white/10
           shadow-[0_8px_25px_rgba(15,23,42,0.12)]
           text-[10px] sm:text-[11px]
           font-semibold
           tracking-tight
           chat-widget-callout-animated"
  >
    <span class="inline-flex items-center gap-1">
      Bizə yazın
      <span class="text-[11px]">👋</span>
    </span>

    <span
      class="absolute -bottom-1 left-5
             w-2 h-2
             bg-white dark:bg-slate-900
             rotate-45
             border-r border-b
             border-slate-200/80 dark:border-white/10"
    ></span>
  </div>


  <div class="relative">

    <!-- CALL OVERLAY -->
    <div
      id="call-overlay"
      class="hidden fixed inset-0 z-[10000]
             bg-black/80 backdrop-blur-2xl
             flex-col items-center justify-center p-6"
    >
      <div
        class="w-full max-w-md
               bg-slate-900
               border border-white/10
               rounded-[2rem]
               p-6
               text-center
               shadow-[0_30px_80px_rgba(0,0,0,0.5)]
               flex flex-col items-center gap-5
               relative overflow-hidden"
      >

        <div
          class="absolute -top-16 -left-16
                 w-40 h-40
                 bg-indigo-500/20
                 rounded-full
                 blur-3xl
                 pointer-events-none"
        ></div>

        <div
          class="absolute -bottom-16 -right-16
                 w-40 h-40
                 bg-blue-500/10
                 rounded-full
                 blur-3xl
                 pointer-events-none"
        ></div>


        <!-- VIDEO AREA -->
        <div
          class="relative w-full aspect-video
                 bg-black/70
                 rounded-3xl
                 overflow-hidden
                 border border-white/10
                 flex items-center justify-center
                 shadow-2xl"
        >

          <video
            id="remoteVideo"
            autoplay
            playsinline
            class="w-full h-full object-cover"
          ></video>

          <video
            id="localVideo"
            autoplay
            playsinline
            muted
            class="hidden w-28 h-36 object-cover rounded-2xl border border-white/20 shadow-xl absolute bottom-3 right-3 z-10"
          ></video>

          <div
            id="call-audio-placeholder"
            class="absolute inset-0
                   flex flex-col items-center justify-center
                   bg-slate-950/90"
          >
            <div
              class="w-24 h-24
                     rounded-full
                     bg-gradient-to-tr from-cyan-500 to-indigo-600
                     p-1
                     animate-pulse
                     shadow-[0_0_40px_rgba(99,102,241,0.35)]"
            >
              <div
                class="w-full h-full
                       bg-slate-950
                       rounded-full
                       flex items-center justify-center
                       text-4xl"
              >
                📞
              </div>
            </div>
          </div>

        </div>


        <!-- CALL USER INFO -->
        <div class="relative z-10">
          <h3
            id="call-name"
            class="text-xl font-extrabold text-white tracking-tight"
          >
            İstifadəçi
          </h3>

          <p
            id="call-status"
            class="text-xs text-slate-400 mt-1.5 font-medium"
          >
            Zəng olunur...
          </p>
        </div>


        <!-- CALLING BUTTONS -->
        <div
          id="calling-call-buttons"
          class="hidden items-center gap-4 mt-2 relative z-10"
        >
          <button
            id="cancel-call-btn"
            type="button"
            class="px-7 py-3
                   rounded-2xl
                   bg-gradient-to-r from-rose-600 to-red-600
                   hover:from-rose-500 hover:to-red-500
                   text-white
                   font-bold
                   text-xs
                   transition-all
                   shadow-lg shadow-rose-600/30
                   active:scale-95"
          >
            🛑 Zəngi Bitir
          </button>
        </div>


        <!-- INCOMING CALL BUTTONS -->
        <div
          id="incoming-call-buttons"
          class="hidden items-center gap-4 mt-2 relative z-10"
        >
          <button
            id="accept-call-btn"
            type="button"
            class="px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-emerald-600 to-green-500
                   hover:from-emerald-500 hover:to-green-400
                   text-white
                   font-bold
                   text-xs
                   transition-all
                   shadow-lg shadow-emerald-600/30
                   active:scale-95"
          >
            📞 Qəbul Et
          </button>

          <button
            id="reject-call-btn"
            type="button"
            class="px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-rose-600 to-red-600
                   hover:from-rose-500 hover:to-red-500
                   text-white
                   font-bold
                   text-xs
                   transition-all
                   shadow-lg shadow-rose-600/30
                   active:scale-95"
          >
            ✕ Rədd Et
          </button>
        </div>


        <!-- CONNECTED CALL BUTTONS -->
        <div
          id="connected-call-buttons"
          class="hidden items-center gap-3 mt-2 relative z-10"
        >
          <button
            id="mute-call-btn"
            type="button"
            class="w-12 h-12
                   flex items-center justify-center
                   rounded-2xl
                   bg-white/10
                   hover:bg-white/20
                   border border-white/10
                   text-white
                   transition-all
                   active:scale-95"
          >
            🎙️
          </button>

          <button
            id="video-call-btn"
            type="button"
            class="w-12 h-12
                   flex items-center justify-center
                   rounded-2xl
                   bg-white/10
                   hover:bg-white/20
                   border border-white/10
                   text-white
                   transition-all
                   active:scale-95"
          >
            📷
          </button>

          <button
            id="end-call-btn"
            type="button"
            class="px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-rose-600 to-red-600
                   hover:from-rose-500 hover:to-red-500
                   text-white
                   font-bold
                   text-xs
                   transition-all
                   shadow-lg shadow-rose-600/30
                   active:scale-95"
          >
            🛑 Zəngi Bitir
          </button>
        </div>

      </div>
    </div>


    <!-- CHAT TOGGLE -->
    <button
      id="chat-widget-toggle"
      type="button"
      class="chat-widget-toggle-premium
             w-12 h-12 sm:w-[52px] sm:h-[52px]
             rounded-[1.15rem]
             text-white
             cursor-pointer
             flex items-center justify-center
             relative
             transition-all duration-300
             hover:-translate-y-1
             hover:scale-105
             active:scale-95"
      aria-label="Chat"
    >
      <span class="chat-toggle-ring chat-toggle-ring-1"></span>
      <span class="chat-toggle-ring chat-toggle-ring-2"></span>

      <span
        class="absolute inset-[3px] rounded-[0.95rem]
               bg-gradient-to-br from-indigo-600 via-violet-600 to-blue-600
               shadow-[0_12px_35px_rgba(79,70,229,0.38)]
               pointer-events-none"
      ></span>

      <span
        class="relative z-10 w-9 h-9 sm:w-10 sm:h-10
               rounded-2xl
               bg-white/10
               border border-white/20
               backdrop-blur-sm
               flex items-center justify-center
               shadow-inner"
      >
        <svg
          class="w-5 h-5 sm:w-[22px] sm:h-[22px]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 10h8M8 14h5M20 11.5c0 4.694-4.477 8.5-10 8.5a11.3 11.3 0 01-4.21-.8L3 21l1.35-3.62A8.05 8.05 0 013 11.5C3 6.806 7.477 3 13 3s8 3.806 8 8.5z"
          />
        </svg>
      </span>

      <!-- MESSAGE BADGE -->
      <span
        id="chat-widget-badge"
        class="hidden absolute -top-1 -right-1
               bg-rose-500
               text-white
               text-[9px]
               font-extrabold
               rounded-full
               min-w-[18px]
               h-[18px]
               px-1
               items-center
               justify-center
               border-2 border-white
               shadow-[0_4px_12px_rgba(244,63,94,0.35)]"
      >
        0
      </span>
    </button>


    <!-- CHAT WINDOW -->
    <div
      id="chat-widget-window"
      class="hidden
             fixed inset-0
             w-full h-full
             sm:fixed sm:inset-auto
             sm:bottom-[68px]
             sm:left-0
             sm:w-[380px]
             md:w-[410px]
             sm:h-[620px]
             bg-white dark:bg-slate-950
             sm:rounded-[2rem]
             shadow-[0_30px_80px_rgba(15,23,42,0.25)]
             flex-col
             overflow-hidden
             border border-slate-200
             z-[999999]"
    >

      <!-- HEADER -->
      <div
        class="bg-white dark:bg-slate-950
               text-slate-900 dark:text-white
               px-4 py-3.5
               flex flex-col gap-2
               shadow-lg
               shrink-0
               relative z-10
               border-b border-slate-200 dark:border-white/10"
      >

        <div class="flex items-center justify-between gap-3 w-full">

          <!-- ADMIN STATUS -->
          <div
            id="chat-widget-admin-status"
            class="flex items-start gap-2 min-w-0 flex-1"
          >

            <span
              id="chat-widget-admin-dot"
              class="w-2 h-2 rounded-full bg-slate-400 shrink-0 mt-1.5"
            ></span>

            <div class="min-w-0 flex flex-col leading-tight">
              <span
                id="chat-widget-admin-text"
                class="text-[11px] font-semibold text-slate-500 dark:text-slate-400"
              >
                Çevrimdışı
              </span>

              <span
                id="chat-widget-admin-activity"
                class="hidden text-[10px] font-medium text-slate-400 dark:text-slate-500 truncate mt-0.5"
              ></span>
            </div>

          </div>

          <!-- HEADER ACTIONS -->
          <div class="flex items-center justify-end gap-1.5 shrink-0">

            <button
              id="start-call-btn"
              type="button"
              class="w-9 h-9 sm:w-10 sm:h-10
                     flex items-center justify-center
                     rounded-xl
                     bg-emerald-50 dark:bg-emerald-500/10
                     hover:bg-emerald-100 dark:hover:bg-emerald-500/20
                     text-emerald-600 dark:text-emerald-400
                     border border-emerald-200 dark:border-emerald-500/20
                     transition-all
                     cursor-pointer
                     hover:scale-105
                     active:scale-95"
              title="Səsli Zəng Et"
              aria-label="Səsli zəng et"
            >
              <span aria-hidden="true">📞</span>
            </button>

            <button
              type="button"
              id="chat-widget-fav-toggle"
              title="Favori Mesajlar"
              aria-label="Favori mesajlar"
              class="w-9 h-9 sm:w-10 sm:h-10
                     rounded-xl
                     text-slate-500 dark:text-slate-300
                     bg-slate-100 dark:bg-white/10
                     hover:bg-slate-200 dark:hover:bg-white/20
                     border border-slate-200 dark:border-white/10
                     transition-all
                     cursor-pointer
                     flex items-center justify-center
                     text-base"
            >
              ⭐
            </button>

            <button
              type="button"
              id="chat-widget-close-mobile"
              aria-label="Çatı bağla"
              class="w-9 h-9 sm:w-10 sm:h-10
                     flex items-center justify-center
                     text-slate-500 dark:text-slate-300
                     hover:text-slate-900 dark:hover:text-white
                     hover:bg-slate-100 dark:hover:bg-white/10
                     rounded-xl
                     text-base
                     font-bold
                     transition-all
                     cursor-pointer"
            >
              ✕
            </button>

          </div>

        </div>

      </div>


      <!-- MESSAGES -->
      <div
        id="chat-widget-messages"
        class="hidden
               flex-1
               px-4 py-3
               sm:px-5 sm:py-4
               overflow-y-auto
               box-border
               w-full
               [-ms-overflow-style:none]
               [scrollbar-width:none]
               [&::-webkit-scrollbar]:hidden
               bg-slate-50 dark:bg-slate-900
               flex-col
               gap-3
               scroll-smooth"
      ></div>


      <!-- TYPING -->
      <div
        id="chat-widget-typing-indicator"
        class="hidden
               px-4 py-2
               text-[11px]
               text-slate-400
               font-medium
               bg-slate-50 dark:bg-slate-900"
      ></div>


      <!-- REPLY -->
      <div
        id="chat-widget-reply-container"
        class="hidden
               shrink-0
               items-center
               justify-between
               bg-indigo-50 dark:bg-indigo-950/40
               p-3 px-4
               border-t border-indigo-100 dark:border-indigo-900/50
               border-l-4 border-l-indigo-600"
      >

        <div class="flex flex-col truncate max-w-[85%]">

          <span
            id="chat-widget-reply-title"
            class="text-[11px] font-bold text-indigo-600"
          ></span>

          <span
            id="chat-widget-reply-text"
            class="text-xs text-slate-600 dark:text-slate-300 truncate mt-0.5"
          ></span>

        </div>

        <button
          type="button"
          id="chat-widget-reply-cancel-btn"
          class="w-7 h-7
                 flex items-center justify-center
                 text-slate-400
                 hover:text-slate-700
                 text-xs
                 font-bold
                 bg-white dark:bg-slate-800
                 rounded-full
                 shadow-sm
                 border border-slate-200 dark:border-slate-700
                 cursor-pointer
                 transition-all"
        >
          ✕
        </button>

      </div>


      <!-- IMAGE PREVIEW -->
      <div
        id="chat-widget-preview-container"
        class="hidden
               shrink-0
               items-center
               bg-slate-100 dark:bg-slate-900
               p-2.5 px-4
               gap-3
               border-t border-slate-200 dark:border-slate-700
               relative"
      >

        <div class="relative inline-block">

          <img
            id="chat-widget-preview-img"
            src=""
            alt="Önizləmə"
            class="h-14 w-14 rounded-xl object-cover border border-slate-300 block shadow-sm"
          >

          <button
            type="button"
            id="chat-widget-cancel-btn"
            class="absolute -top-2 -right-2
                   bg-rose-500
                   hover:bg-rose-600
                   text-white
                   border-2 border-white
                   rounded-full
                   w-5 h-5
                   cursor-pointer
                   text-[10px]
                   flex items-center justify-center
                   font-bold
                   shadow-md
                   transition-all"
          >
            ✕
          </button>

        </div>

        <span
          id="chat-widget-preview-name"
          class="text-xs
                 text-slate-600 dark:text-slate-300
                 font-medium
                 truncate
                 max-w-[200px]"
        ></span>

      </div>


      <!-- VOICE -->
      <div
        id="chat-widget-voice-container"
        class="hidden
               shrink-0
               items-center
               justify-between
               bg-rose-50
               p-3 px-4
               border-t border-rose-100"
      >

        <div class="flex items-center gap-3 flex-1 min-w-0">

          <span
            id="chat-widget-voice-ping"
            class="w-2.5 h-2.5
                   bg-rose-500
                   rounded-full
                   animate-ping
                   shrink-0"
          ></span>

          <span
            id="chat-widget-voice-timer"
            class="text-xs
                   text-rose-700
                   font-bold
                   font-mono
                   shrink-0"
          >
            00:00
          </span>

          <div
            id="chat-widget-voice-waves"
            class="flex items-center gap-1 h-5 px-2 flex-1 overflow-hidden"
          >

            <span class="w-1 bg-rose-400 rounded-full h-2 animate-pulse"></span>
            <span class="w-1 bg-rose-500 rounded-full h-4 animate-pulse"></span>
            <span class="w-1 bg-rose-400 rounded-full h-1 animate-pulse"></span>
            <span class="w-1 bg-rose-500 rounded-full h-3 animate-pulse"></span>

          </div>

        </div>

        <button
          type="button"
          id="chat-widget-voice-cancel-btn"
          class="text-rose-600
                 hover:text-rose-700
                 font-semibold
                 text-xs
                 px-2
                 cursor-pointer
                 shrink-0"
        >
          İptal
        </button>

      </div>


      <!-- MESSAGE FORM -->
      <form
        id="chat-widget-form"
        class="hidden
               shrink-0
               items-center
               border-t border-slate-200 dark:border-slate-700
               p-2.5 sm:p-3
               bg-white dark:bg-slate-950
               gap-1.5 sm:gap-2"
      >

        <input
          type="file"
          id="chat-widget-file"
          accept="image/*"
          class="hidden"
        >

        <button
          type="button"
          id="chat-widget-file-btn"
          class="w-10 h-10
                 flex items-center justify-center
                 text-slate-400
                 hover:text-indigo-600
                 hover:bg-indigo-50
                 rounded-xl
                 transition-all
                 cursor-pointer
                 shrink-0"
        >
          📷
        </button>


        <button
          type="button"
          id="chat-widget-voice-btn"
          class="w-10 h-10
                 flex items-center justify-center
                 text-slate-400
                 hover:text-indigo-600
                 hover:bg-indigo-50
                 rounded-xl
                 transition-all
                 cursor-pointer
                 shrink-0"
        >
          <span id="voice-btn-icon">🎙️</span>
        </button>


        <input
          id="chat-widget-input"
          type="text"
          placeholder="Mesajınızı yazın..."
          class="flex-1
                 h-10
                 py-2 px-3
                 bg-slate-100 dark:bg-slate-900
                 border border-transparent
                 rounded-2xl
                 text-[16px]
                 font-medium
                 text-slate-800 dark:text-slate-100
                 placeholder-slate-400
                 focus:bg-white dark:focus:bg-slate-800
                 focus:border-indigo-400
                 focus:ring-2 focus:ring-indigo-100
                 focus:outline-none
                 transition-all
                 min-w-0"
          autocomplete="off"
        >


        <button
          type="submit"
          id="chat-widget-submit-btn"
          class="w-10 h-10
                 bg-gradient-to-br from-indigo-600 to-blue-600
                 hover:from-indigo-500 hover:to-blue-500
                 text-white
                 rounded-xl
                 cursor-pointer
                 font-semibold
                 text-sm
                 shadow-md
                 shadow-indigo-500/20
                 transition-all
                 active:scale-90
                 flex items-center justify-center
                 shrink-0"
        >
          ➤
        </button>

      </form>

    </div>

  </div>

</div>


<!-- IMAGE VIEWER -->
<div
  id="imageViewer"
  class="hidden
         fixed inset-0
         bg-black/95
         backdrop-blur-sm
         z-[99999999]
         items-center justify-center
         p-4"
>

  <button
    id="close-image-btn"
    type="button"
    class="absolute top-5 right-5
           w-12 h-12
           flex items-center justify-center
           text-white
           text-3xl
           font-bold
           bg-white/10
           hover:bg-white/20
           rounded-full
           border border-white/10
           transition-all"
  >
    ×
  </button>

  <img
    id="imageViewerImg"
    class="max-w-full max-h-[90vh] object-contain rounded-xl shadow-2xl"
    src=""
    alt=""
  >

</div>
`;



export default function ChatWidget() {


  


  const rootRef = useRef(null);
  const mountedRef = useRef(false);
  const dispatch = useDispatch();

  const userInfo = useSelector(
    (state) => state.auth?.userInfo
  );

  const bridgeRef = useRef({
    dispatch,
    userInfo: null
  });

  bridgeRef.current.userInfo = userInfo;

  useEffect(() => {
    if (!rootRef.current || mountedRef.current) return undefined;
    mountedRef.current = true;

    const root = rootRef.current;
    root.innerHTML = CHAT_MARKUP;

    const storeBridge = bridgeRef.current;

    try {
      // Legacy kodun socket/WebRTC/event davranışı korunur; yalnızca bu JSX daxilində saxlanılır.
      // eslint-disable-next-line no-new-func
      const run = new Function("io", "store", CHAT_LEGACY_SCRIPT);
      run(io, storeBridge);

      if (typeof window.refreshChatWelcome === "function") {
        window.refreshChatWelcome();
      }
    } catch (error) {
      console.error("Chat widget başladılarkən xəta:", error);
    }

    const sync = () => {
      const category = localStorage.getItem("chat_category");
      if (category) dispatch(setSelectedCategory(category));

      const badge = root.querySelector("#chat-widget-badge");
      const unread = badge ? Number((badge.textContent || "0").replace("+", "")) || 0 : 0;
      dispatch(setUnreadCount(unread));

      const adminText = root.querySelector("#chat-widget-admin-text");
      if (adminText) {
        const text = adminText.textContent.trim();
        dispatch(setAdminOnline(text === "Çevrimiçi" || text === "Onlayın"));
      }

      const overlay = root.querySelector("#call-overlay");
      const status = root.querySelector("#call-status");
      if (overlay && !overlay.classList.contains("hidden")) {
        const text = status?.textContent?.trim() || "";
        if (text.includes("Gələn")) dispatch(setCallState("incoming"));
        else if (text.includes("Zəng olunur")) dispatch(setCallState("calling"));
        else if (text.includes("Canlı") || text.includes("Görüntülü")) dispatch(setCallState("connected"));
      } else {
        dispatch(setCallState("idle"));
      }

      const mute = root.querySelector("#mute-call-btn");
      if (mute) dispatch(setMuted((mute.textContent || "").includes("🔇")));
      const localVideo = root.querySelector("#localVideo");
      dispatch(setVideoOn(Boolean(localVideo && !localVideo.classList.contains("hidden"))));
    };

    const observer = new MutationObserver(sync);
    observer.observe(root, { subtree: true, childList: true, attributes: true, characterData: true });
    sync();

    return () => {
      observer.disconnect();
      // Legacy socket intentionally remains persistent to preserve original reconnect behavior.
    };
  }, [dispatch]);

  useEffect(() => {
    bridgeRef.current.userInfo = userInfo;

    if (typeof window !== "undefined" && typeof window.refreshChatWelcome === "function") {
      const welcome = document.getElementById("local-chat-welcome-message");
      if (welcome) {
        welcome.remove();
      }
      window.refreshChatWelcome();
    }
  }, [userInfo]);

  return <div ref={rootRef} />;
}
